webpackJsonprequire([2],{

/***/ 38:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(331);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/legacy/Stamp.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/legacy/Stamp.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 127:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1),
	    PureRenderMixin = __webpack_require__(2),
	    TransitionEventsMixin = __webpack_require__(167);

	/**
	 * This is just like <img /> but with onTransitionEnd event
	 * that React doesn't support out of the box.
	 */
	var Img = React.createClass({
	  displayName: 'Img',

	  mixins: [TransitionEventsMixin, PureRenderMixin],

	  propTypes: {
	    onTransitionEnd: React.PropTypes.func.isRequired,
	    preventSave: React.PropTypes.bool.isRequired
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      preventSave: true
	    };
	  },

	  render: function render() {
	    return React.createElement('img', _extends({}, this.props, {
	      onContextMenu: this.handleContextMenu,
	      onDragStart: this.handleDragStart }));
	  },

	  handleTransitionEnd: function handleTransitionEnd() {
	    this.props.onTransitionEnd();
	  },

	  handleContextMenu: function handleContextMenu(e) {
	    if (this.props.preventSave) {
	      e.preventDefault();
	    } else if (this.props.onContextMenu) {
	      this.props.onContextMenu(e);
	    }
	  },

	  handleDragStart: function handleDragStart(e) {
	    if (this.props.preventSave) {
	      e.preventDefault();
	    } else if (this.props.onDragStart) {
	      this.props.onDragStart(e);
	    }
	  } });

	module.exports = Img;

/***/ },

/***/ 130:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ResponsiveImageQueueMixin = __webpack_require__(86);
	var ViewportTestMixin = __webpack_require__(168);
	var ImageStore = __webpack_require__(146);
	var UserStore = __webpack_require__(5);
	var ImageUsageCounter = __webpack_require__(264);
	var ImageAttribution = __webpack_require__(263);
	var assign = __webpack_require__(15);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;var PropTypes = React.PropTypes;

	/**
	 * Provides an image queue for images inside the stamp, considering window width,
	 * whether lightbox is active and whether image is close to the viewport.
	 * Expects `getImage` to be defined and to return a valid `ImageMedia`.
	 */
	var StampImageMixin = {
	  mixins: [ResponsiveImageQueueMixin, ViewportTestMixin],

	  propTypes: {
	    lightboxState: PropTypes.oneOf(['active', 'leaving']),
	    isImageInLightbox: PropTypes.func.isRequired,
	    stamp: PropTypes.object.isRequired
	  },

	  getInitialState: function getInitialState() {
	    return assign({
	      isAttributionVisible: false
	    }, this.getStateFromImageStore(this.props));
	  },

	  getStateFromImageStore: function getStateFromImageStore(props) {
	    var stampId = props.stamp.id,
	        inlineImage = this.getImage(props),
	        image = ImageStore.getInStamp(inlineImage.uuid, stampId),
	        sourceStamp,
	        sourceImage,
	        sourceUser;

	    if (image) {
	      sourceImage = ImageStore.getSourceImage(image);
	      sourceStamp = ImageStore.getSourceStamp(image, stampId);
	      sourceUser = UserStore.get(sourceStamp.user);
	    }

	    return { sourceImage: sourceImage, sourceStamp: sourceStamp, sourceUser: sourceUser };
	  },

	  canRenderAttribution: function canRenderAttribution() {
	    var _state = this.state;
	    var sourceStamp = _state.sourceStamp;
	    var sourceImage = _state.sourceImage;var stamp = this.props.stamp;

	    if (!sourceImage || !sourceStamp || !stamp) {
	      return false;
	    }

	    var hasSourceStamp = sourceStamp.id !== stamp.id,
	        hasOtherUsages = sourceImage && sourceImage.usageCount > 0;

	    return hasSourceStamp || hasOtherUsages;
	  },

	  componentDidMount: function componentDidMount() {
	    ImageStore.addChangeListener(this.handleImageStoreChange);
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.getImage(nextProps) !== this.getImage(this.props)) {
	      this.setState(this.getStateFromImageStore(nextProps));
	    }
	  },

	  handleImageStoreChange: function handleImageStoreChange() {
	    this.setState(this.getStateFromImageStore(this.props));
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.lightboxState !== this.props.lightboxState || prevState.isInViewport !== this.state.isInViewport) {

	      this.updateImageQueue();
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    ImageStore.removeChangeListener(this.handleImageStoreChange);
	  },

	  getImageOptions: function getImageOptions() {
	    var image = this.getImage(this.props);
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    return {
	      image: image,
	      sizes: {
	        thumb: true,
	        small: this.state.imageSize > 500,
	        normal: true,
	        retina: devicePixelRatio > 1.5 && this.state.isInViewport,
	        original: this.props.isImageInLightbox(image)
	      },
	      allowEmpty: this.props.allowEmpty
	    };
	  },

	  renderUsageCounter: function renderUsageCounter() {
	    var _state2 = this.state;
	    var sourceImage = _state2.sourceImage;
	    var isAttributionVisible = _state2.isAttributionVisible;

	    if (!sourceImage || isAttributionVisible) {
	      return;
	    }

	    if (sourceImage.usageCount > 0) {
	      return React.createElement(ImageUsageCounter, { counter: sourceImage.usageCount });
	    }
	  },

	  renderAttributionOnMobile: function renderAttributionOnMobile() {
	    if (!this.state.isAttributionVisible) {
	      return;
	    }

	    if (!this.canRenderAttribution()) {
	      return;
	    }

	    var stamp = this.props.stamp;var _state3 = this.state;
	    var sourceStamp = _state3.sourceStamp;
	    var sourceImage = _state3.sourceImage;
	    var sourceUser = _state3.sourceUser;

	    return React.createElement(ImageAttribution, { sourceStamp: sourceStamp,
	      sourceImage: sourceImage,
	      sourceUser: sourceUser,
	      stamp: stamp });
	  },

	  toggleAttributionOnMobile: function toggleAttributionOnMobile(e) {
	    if (!isMobile()) {
	      return;
	    }

	    e.stopPropagation();

	    var isAttributionVisible = this.state.isAttributionVisible;
	    this.setState({
	      isAttributionVisible: !isAttributionVisible
	    });
	  }
	};

	module.exports = StampImageMixin;

/***/ },

/***/ 164:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var ResponsiveImageQueueMixin = __webpack_require__(86);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var gradient = __webpack_require__(123);var PropTypes = React.PropTypes;

	__webpack_require__(332);

	var BlurredBackground = React.createClass({
	  displayName: 'BlurredBackground',

	  mixins: [ResponsiveImageQueueMixin, PureRenderMixin, ClassNameMixin],

	  propTypes: {
	    background: PropTypes.shape({
	      url: PropTypes.string.isRequired
	    }).isRequired
	  },

	  getImageSizes: function getImageSizes() {
	    return {
	      'default': 480,
	      'xs': 640,
	      'sm': 640,
	      'md': 640,
	      'lg': 640,
	      'xl': 640
	    };
	  },

	  getImageOptions: function getImageOptions() {
	    return {
	      image: this.props.background,
	      blur: 32,
	      sizes: {
	        small: true,
	        normal: true
	      }
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps.background !== this.props.background) {
	      this.updateImageQueue();
	    }
	  },

	  render: function render() {
	    var colors = this.props.background.colors,
	        hasLoadedImage = this.hasLoadedImage(),
	        style = {};

	    if (hasLoadedImage) {
	      style.backgroundImage = this.getBackgroundImageUrl();
	    } else {
	      style.backgroundImage = gradient('#' + colors.top, '#' + colors.bottom);
	    }

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        style: style },
	      this.renderLoaderImg()
	    );
	  }
	});

	module.exports = BlurredBackground;

/***/ },

/***/ 173:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PlayerTitle = __webpack_require__(251);
	var BlurredBackground = __webpack_require__(164);
	var PureRenderMixin = __webpack_require__(2);
	var supportsPositionSticky = __webpack_require__(300);
	var ClassNameMixin = __webpack_require__(3);var PropTypes = React.PropTypes;

	__webpack_require__(38);
	__webpack_require__(335);

	var AudioContainer = React.createClass({
	  displayName: 'AudioContainer',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    background: PropTypes.object.isRequired,
	    title: PropTypes.string.isRequired,
	    username: PropTypes.string.isRequired,
	    duration: PropTypes.number.isRequired,
	    url: PropTypes.string.isRequired,
	    cover: PropTypes.node.isRequired,
	    trackList: PropTypes.node
	  },

	  className: 'stamp-AudioContainer',

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      supportsSticky: supportsPositionSticky()
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        'data-scroll-anchor': true },
	      React.createElement(
	        'div',
	        { className: 'stamp-AudioContainer-container' },
	        React.createElement(
	          'div',
	          { className: 'stamp-AudioContainer-bg' },
	          React.createElement(BlurredBackground, { background: this.props.background })
	        ),
	        React.createElement(
	          'div',
	          { className: 'stamp-AudioContainer-box' },
	          React.createElement(
	            'div',
	            { className: 'stamp-AudioContainer-player' },
	            this.props.cover
	          ),
	          React.createElement(
	            'div',
	            { className: 'stamp-AudioContainer-meta' },
	            React.createElement(PlayerTitle, { title: this.props.title,
	              username: this.props.username,
	              duration: this.props.duration,
	              linkUrl: this.props.url }),
	            this.props.trackList
	          )
	        )
	      )
	    );
	  }
	});

	module.exports = AudioContainer;

/***/ },

/***/ 174:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    Img = __webpack_require__(127),
	    ImageCaption = __webpack_require__(175),
	    StampImageMixin = __webpack_require__(130),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(339);

	var GalleryImage = React.createClass({
	  displayName: 'GalleryImage',

	  mixins: [PureRenderMixin, StampImageMixin],

	  propTypes: {
	    stamp: React.PropTypes.object.isRequired,
	    className: React.PropTypes.string.isRequired,
	    style: React.PropTypes.object,
	    caption: React.PropTypes.string,
	    image: React.PropTypes.object.isRequired,
	    imageStyle: React.PropTypes.object,
	    imageSizes: React.PropTypes.object,
	    onTransitionEnd: React.PropTypes.func.isRequired,
	    onClick: React.PropTypes.func.isRequired
	  },

	  getImage: function getImage(props) {
	    return props.image;
	  },

	  getImageSizes: function getImageSizes() {
	    return this.props.imageSizes;
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.props.className,
	        'data-scroll-anchor': true,
	        onClick: this.toggleAttributionOnMobile,
	        style: this.props.style },
	      React.createElement(
	        'div',
	        { className: 'stamp-GalleryImage' },
	        React.createElement(
	          'div',
	          { className: 'stamp-GalleryImage-imageWrapper' },
	          React.createElement(Img, { src: this.getImageSrcUrl(),
	            style: this.props.imageStyle,
	            onClick: this.handleImageClick,
	            onTransitionEnd: this.props.onTransitionEnd,
	            onLoad: this.handleImageLoad,
	            onError: this.handleImageError }),
	          this.renderUsageCounter(),
	          this.renderAttributionOnMobile()
	        ),
	        this.props.caption.length > 0 && React.createElement(ImageCaption, { caption: this.props.caption })
	      )
	    );
	  },

	  handleImageClick: function handleImageClick(e) {
	    this.props.onClick(this.props.image, e);
	  }
	});

	module.exports = GalleryImage;

/***/ },

/***/ 175:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ClassNameMixin = __webpack_require__(3),
	    FontTest = __webpack_require__(92),
	    PureRenderMixin = __webpack_require__(2);

	__webpack_require__(38);
	__webpack_require__(341);

	var ImageCaption = React.createClass({
	  displayName: 'ImageCaption',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  className: 'stamp-ImageCaption',

	  propTypes: {
	    caption: React.PropTypes.string.isRequired
	  },

	  render: function render() {
	    var caption = this.props.caption;

	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(
	        'div',
	        { className: 'stamp-ImageCaption-box' },
	        React.createElement(
	          FontTest,
	          { family: 'minion-pro-condensed',
	            test: caption },
	          React.createElement('div', { className: 'stamp-ImageCaption-text',
	            dangerouslySetInnerHTML: { __html: caption } })
	        )
	      )
	    );
	  }
	});

	module.exports = ImageCaption;

/***/ },

/***/ 202:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  GRID: 'grid',
	  LIST: 'list'
	};

/***/ },

/***/ 218:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var shallowEqual = __webpack_require__(46);

	/**
	 * A helper to avoid creating immutable objects
	 * if they don't differ from previous values.
	 */
	function firstIfShallowEqual(first, second) {
	  if (!first || !second) {
	    return second;
	  }

	  return shallowEqual(first, second) ? first : second;
	}

	module.exports = firstIfShallowEqual;

/***/ },

/***/ 222:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Promise = __webpack_require__(99)['default'];

	var getScrollY = __webpack_require__(82);

	/**
	 * Waits for elastic bounce to finish.
	 * Thanks to rAF calls, it doesn't cause unneccessary layout.
	 */
	function waitForElasticScroll() {
	  return new _Promise(function (resolve) {
	    window.requestAnimationFrame(function () {
	      var maxScrollY = document.body.scrollHeight - window.innerHeight;

	      function isReady() {
	        var scrollY = getScrollY();
	        return scrollY >= 0 && scrollY <= maxScrollY;
	      }

	      function resolveIfReady() {
	        if (isReady()) {
	          resolve();
	        } else {
	          window.requestAnimationFrame(resolveIfReady);
	        }
	      }

	      resolveIfReady();
	    });
	  });
	}

	module.exports = waitForElasticScroll;

/***/ },

/***/ 249:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var AppDispatcher = __webpack_require__(6),
	    ActionTypes = __webpack_require__(9);

	var LightboxActionCreators = {
	  showLightbox: function showLightbox(image, sectionType) {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.ENTER_LIGHTBOX,
	      image: image,
	      sectionType: sectionType
	    });
	  },

	  hideLightbox: function hideLightbox() {
	    AppDispatcher.handleViewAction({
	      type: ActionTypes.LEAVE_LIGHTBOX
	    });
	  } };

	module.exports = LightboxActionCreators;

/***/ },

/***/ 254:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var keyMirror = __webpack_require__(24);

	module.exports = keyMirror({
	  VIMEO: null,
	  SOUNDCLOUD: null
	});

/***/ },

/***/ 255:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4),
	    SmoothScrollMixin = __webpack_require__(259),
	    getScrollY = __webpack_require__(82);

	var ASSUMED_LINE_HEIGHT = 40,
	    ANIMATE_DURATION = 200;

	function getScrollAnchors(viewportHeight, el, id) {
	  var rect = el.getBoundingClientRect(),
	      rectCenter = (rect.bottom - rect.top) / 2,
	      type = el.getAttribute('data-scroll-anchor') || 'image',
	      viewportMiddle = viewportHeight / 2,
	      element;

	  element = {
	    id: id,
	    type: type
	  };

	  if (rectCenter > viewportMiddle) {
	    return [{ el: element, shift: rect.top }, { el: element, shift: rect.bottom - viewportHeight }];
	  } else {
	    return { el: element, shift: rect.top + rectCenter - viewportMiddle };
	  }
	}

	/**
	 * Provides keydown and keyup handlers that, when invoked, will mimic browser
	 * scrolling but the scroll will snap, when close enough, to the center of
	 * the next (or previous) child with `data-scroll-anchor` attribute.
	 *
	 * You can optionally specify scroll anchor type (`text` or `image`) as the
	 * value of `data-scroll-anchor` attribute. By default, `image` is assumed.
	 * This changes how much content we are allowed to skip when snapping. We may
	 * skip tall image's start and end, but we may not skip any part of the text.
	 *
	 * The calling code must explicitly subscribe to `keydown` and `keyup` events,
	 * check `isSpaceKeyEvent` and call `handleSpaceKeyUp` and `handleSpaceKeyDown`
	 * when appropriate. This allows the calling code to have more control over
	 * what happens.
	 */
	var AnchorScrollMixin = {
	  mixins: [SmoothScrollMixin],

	  isSpaceKeyEvent: function isSpaceKeyEvent(e) {
	    return e.keyCode === 32;
	  },

	  isSpaceKeyHeld: function isSpaceKeyHeld() {
	    return this._isSpaceKeyHeld;
	  },

	  handleSpaceKeyUp: function handleSpaceKeyUp() {
	    this._isSpaceKeyHeld = false;
	  },

	  handleSpaceKeyDown: function handleSpaceKeyDown(e) {
	    if (e.target !== document.body) {
	      return;
	    }

	    var shouldBailOut = this.isSpaceKeyHeld();
	    if (shouldBailOut) {
	      return;
	    }

	    this._isSpaceKeyHeld = true;

	    var isForward = !e.shiftKey,
	        candidateAnchorY = this._getCandidateAnchorY(isForward);

	    if (_.isNumber(candidateAnchorY)) {
	      e.preventDefault();
	      this.animateScroll(candidateAnchorY, ANIMATE_DURATION);
	      this._lastTargetY = candidateAnchorY;
	    }
	  },

	  _getCandidateAnchorY: function _getCandidateAnchorY(isForward) {
	    var vh = window.innerHeight,
	        scrollY = getScrollY(),
	        lastTargetY = this.isAnimatingScroll() ? this._lastTargetY : scrollY,
	        anchors = this._findScrollAnchors(vh),
	        maxCrossSectionShift = vh * 1.5,
	        maxInSectionShift = vh - ASSUMED_LINE_HEIGHT,
	        minPhotoShift = vh / 3,
	        minTextShift = ASSUMED_LINE_HEIGHT * 2,
	        prevAnchor,
	        anchor,
	        shift;

	    function getMinShift(anchor, prevAnchor) {
	      return prevAnchor && prevAnchor.el.type === 'text' ? minTextShift : minPhotoShift;
	    }

	    function getMaxShift(anchor, prevAnchor) {
	      return prevAnchor && prevAnchor.el.id === anchor.el.id ? maxInSectionShift : maxCrossSectionShift;
	    }

	    anchor = _.chain(anchors).each(function (anchor) {
	      anchor.shift += lastTargetY - scrollY;
	    }).sortBy(function (anchor) {
	      return isForward ? anchor.shift : -anchor.shift;
	    }).find(function (anchor) {
	      var isNext = isForward ? anchor.shift > getMinShift(anchor, prevAnchor) : anchor.shift < -getMinShift(anchor, prevAnchor);

	      if (!isNext) {
	        prevAnchor = anchor;
	      }

	      return isNext;
	    }).value();

	    if (!anchor) {
	      return;
	    }

	    shift = isForward ? Math.min(anchor.shift, getMaxShift(anchor, prevAnchor)) : Math.max(anchor.shift, -getMaxShift(anchor, prevAnchor));

	    if (Math.abs(shift) > getMinShift(anchor, prevAnchor)) {
	      return Math.round(lastTargetY + shift);
	    }
	  },

	  _findScrollAnchors: function _findScrollAnchors(viewportHeight) {
	    var el = this.getDOMNode(),
	        scrollAnchorEls = _.toArray(el.querySelectorAll('[data-scroll-anchor]'));

	    return _.chain(scrollAnchorEls).map(_.partial(getScrollAnchors, viewportHeight)).flatten().value();
	  }
	};

	module.exports = AnchorScrollMixin;

/***/ },

/***/ 257:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(4);
	var getScrollY = __webpack_require__(82);
	var SectionTypes = __webpack_require__(40);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;

	var isIE10 = _require.isIE10;
	var firstIfShallowEqual = __webpack_require__(218);

	var OFFSCREEN_FADING = {
	  isActive: false,
	  isVisible: false,
	  topOpacity: 0,
	  bottomOpacity: 0
	};

	function isPageVisible() {
	  var hidden = document.hidden;
	  if (!_.isBoolean(hidden)) {
	    hidden = false;
	  }

	  return !hidden;
	}

	function interpolate(val, points) {
	  if (points[0] === points[1]) {
	    return points[0];
	  }

	  var result = (val - points[0]) / (points[1] - points[0]),
	      precision = 1 / (window.safari ? 0.1 : 0.02);

	  result = Math.min(1, Math.max(0, result));
	  result = Math.round(result * precision) / precision;
	  return result;
	}

	/**
	 * Keeps track of fading for posters as user scrolls the window.
	 * Expects `getSectionNode(i)` to be defined.
	 */
	var FadingCalculatorMixin = {
	  getInitialState: function getInitialState() {
	    return {
	      posterFadings: null
	    };
	  },

	  isFadingEnabled: function isFadingEnabled() {
	    // On IE10, we don't have pointer-events
	    // and fades make some buttons unclickable.
	    return !isIE10() && !isMobile();
	  },

	  /**
	   * Returns an object with following properties:
	   *
	   * - isActive: whether a poster is active at the moment
	   * - top: top fading opacity, 0 to 1
	   * - bottom: bottom fading opacity, 0 to 1
	   *
	   * @param {number} index Index of the poster.
	   */
	  getSectionFading: function getSectionFading(index) {
	    if (!this.isFadingEnabled()) {
	      return;
	    }

	    var sections = this.state.sections || [],
	        fadings = this.state.posterFadings || [],
	        type = sections[index].type;

	    if (type === SectionTypes.POSTER || type === SectionTypes.COVER) {
	      return fadings[index] || OFFSCREEN_FADING;
	    }
	  },

	  componentDidMount: function componentDidMount() {
	    if (!this.isFadingEnabled()) {
	      return;
	    }

	    this._sectionHeights = [];
	    this._updateSectionHeights();

	    window.addEventListener('scroll', this._updatePosterFadings);
	    window.addEventListener('visibilitychange', this._updateSectionHeights);
	    window.addEventListener('resize', this._updateSectionHeights);
	    this._updateHeightsInterval = setInterval(this._updateSectionHeights, 700);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    if (!this.isFadingEnabled()) {
	      return;
	    }

	    clearInterval(this._updateHeightsInterval);
	    window.removeEventListener('visibilitychange', this._updateSectionHeights);
	    window.removeEventListener('resize', this._updateSectionHeights);
	    window.removeEventListener('scroll', this._updatePosterFadings);
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (!this.isFadingEnabled()) {
	      return;
	    }

	    if (this.state.sections !== prevState.sections) {
	      this._updateSectionHeights();
	    }
	  },

	  _updateSectionHeights: function _updateSectionHeights() {
	    if (!this.isMounted()) {
	      return;
	    }

	    if (!isPageVisible()) {
	      return;
	    }

	    var count = this.state.sections.length,
	        node,
	        offsetHeight,
	        didChange;

	    if (this._sectionHeights.length !== count) {
	      this._sectionHeights.length = count;
	      didChange = true;
	    }

	    for (var i = 0; i < count; i++) {
	      node = this.getSectionNode(i);
	      offsetHeight = node.offsetHeight;

	      if (offsetHeight !== this._sectionHeights[i]) {
	        this._sectionHeights[i] = offsetHeight;
	        didChange = true;
	      }
	    }

	    if (didChange) {
	      this._updatePosterFadings();
	    }
	  },

	  _updatePosterFadings: function _updatePosterFadings() {
	    if (!this.isMounted()) {
	      return;
	    }

	    var scrollY = getScrollY(),
	        sectionHeights = this._sectionHeights,
	        boundingRects = this._getBoundingRects(sectionHeights, scrollY),
	        state = this._getFadingState(boundingRects);

	    this.setState(state);
	  },

	  /**
	   * Calculates active poster index and fading.
	   *
	   * @param {array<object>} boundingRects Bounding rects for each section.
	   */
	  _getFadingState: function _getFadingState(boundingRects) {
	    var prevPosterFadings = this.state.posterFadings,
	        viewportHeight = window.innerHeight,
	        sectionCount = this.state.sections.length,
	        visiblePosters = this._findVisiblePosters(boundingRects, viewportHeight),
	        activePoster = this._findActivePoster(visiblePosters, viewportHeight),
	        posterFadings = null;

	    if (visiblePosters.length) {
	      posterFadings = new Array(sectionCount);
	    }

	    for (var visibleIndex = 0; visibleIndex < visiblePosters.length; visibleIndex++) {
	      var poster = visiblePosters[visibleIndex],
	          posterIndex = poster.index,
	          rect = poster.rect,
	          fading;

	      if (!rect.height) {
	        continue;
	      }

	      fading = this._getVisiblePosterFading(posterIndex, rect, poster === activePoster, boundingRects, viewportHeight);

	      // Avoid updating object if all its values match the previous fading
	      // so that the component can benefit from reference equality check on fading.

	      if (prevPosterFadings) {
	        fading = firstIfShallowEqual(prevPosterFadings[posterIndex], fading);
	      }

	      posterFadings[posterIndex] = fading;
	    }

	    // If *all* values in array are the same, avoid changes.
	    posterFadings = firstIfShallowEqual(prevPosterFadings, posterFadings);

	    return {
	      posterFadings: posterFadings
	    };
	  },

	  _getVisiblePosterFading: function _getVisiblePosterFading(index, rect, isActive, boundingRects, viewportHeight) {
	    if (!rect.height) {
	      return;
	    }

	    var fading = {
	      isVisible: true,
	      isActive: isActive,
	      progress: this._getPosterProgress(rect, viewportHeight),
	      topOpacity: 0,
	      bottomOpacity: 0
	    };

	    if (isActive) {
	      var isTall = rect.height > viewportHeight,
	          isCover = this.state.sections[index].type === SectionTypes.COVER,
	          isBeforeInfo = this.state.sections[index + 1].type === SectionTypes.INFO,
	          posterDistances = this._getDistanceToPosters(index, boundingRects),
	          opacities;

	      opacities = isTall || isCover ? this._getTallPosterOpacities(rect, viewportHeight, posterDistances) : this._getShortPosterOpacities(rect, viewportHeight, posterDistances);

	      if (isBeforeInfo) {
	        opacities.bottom = 0;
	      }

	      fading.topOpacity = opacities.top;
	      fading.bottomOpacity = opacities.bottom;
	    }

	    return fading;
	  },

	  _getDistanceToPosters: function _getDistanceToPosters(index, boundingRects) {
	    var distanceToPrev = 0,
	        distanceToNext = 0,
	        sections = this.state.sections,
	        i;

	    for (i = index - 1; i >= 0; i--) {
	      if (sections[i].type === SectionTypes.POSTER) {
	        break;
	      }

	      distanceToPrev += boundingRects[i].height;
	    }

	    for (i = index + 1; i < boundingRects.length; i++) {
	      if (sections[i].type === SectionTypes.POSTER) {
	        break;
	      }

	      distanceToNext += boundingRects[i].height;
	    }

	    return {
	      next: distanceToNext,
	      prev: distanceToPrev
	    };
	  },

	  _getShortPosterOpacities: function _getShortPosterOpacities(rect, viewportHeight, posterDistances) {
	    var top = rect.top,
	        height = rect.height,
	        viewportMiddle = viewportHeight / 2,
	        isTooCloseToPrevPoster = posterDistances.prev > 0 && posterDistances.prev < viewportHeight,
	        isTooCloseToNextPoster = posterDistances.next > 0 && posterDistances.next < viewportHeight;

	    return {
	      top: interpolate(top, {
	        0: isTooCloseToPrevPoster ? viewportMiddle + posterDistances.prev / 4 : viewportHeight,

	        1: viewportHeight - height
	      }),
	      bottom: interpolate(top, {
	        1: 0,
	        0: isTooCloseToNextPoster ? viewportMiddle - (rect.height + posterDistances.next / 4) : -viewportMiddle
	      })
	    };
	  },

	  _getTallPosterOpacities: function _getTallPosterOpacities(rect, viewportHeight, posterDistances) {
	    var top = rect.top,
	        bottom = rect.bottom,
	        fadeInEarlier = posterDistances.prev > 0 && posterDistances.prev < viewportHeight,
	        fadeInTop,
	        fadeInDistance;

	    if (posterDistances.prev > 0) {
	      fadeInTop = viewportHeight / 2;
	      if (!fadeInEarlier) {
	        fadeInTop += viewportHeight / 4;
	      }

	      fadeInDistance = viewportHeight / 2;
	    } else {
	      fadeInTop = viewportHeight;
	      fadeInDistance = viewportHeight;
	    }
	    return {
	      top: interpolate(top, {
	        0: fadeInTop,
	        1: fadeInTop - fadeInDistance
	      }),
	      bottom: interpolate(bottom, {
	        1: viewportHeight,
	        0: viewportHeight / 2
	      })
	    };
	  },

	  _getPosterProgress: function _getPosterProgress(rect, viewportHeight) {
	    var viewportMiddle = viewportHeight / 2;

	    return interpolate(rect.top, {
	      0: viewportMiddle,
	      1: viewportMiddle - rect.height
	    });
	  },

	  /**
	   * Finds the single active poster, if any.
	   * Assumes an array of { index, section, rect }.
	   *
	   * To find the active poster, it takes all visible posters and finds
	   * the one that either intersects viewport middle, or has
	   * the minimal distance from its edge to the viewport middle.
	   *
	   * @param {array<object>} visiblePosters All posters at least partially visible now.
	   * @param {number} viewportHeight Viewport height.
	   */
	  _findActivePoster: function _findActivePoster(visiblePosters, viewportHeight) {
	    if (!visiblePosters.length) {
	      return;
	    }

	    var viewportMiddle = viewportHeight / 2;
	    return _.min(visiblePosters, function (poster) {
	      var rect = poster.rect;
	      if (rect.top <= viewportMiddle && rect.bottom >= viewportMiddle) {
	        return 0;
	      }

	      return Math.min(Math.abs(rect.top - viewportMiddle), Math.abs(rect.bottom - viewportMiddle));
	    });
	  },

	  /**
	   * Finds posters that at least partially intersect the viewport.
	   * For matching posters, returns { index, section, rect }.
	   *
	   * @param {array<object>} boundingRects Bounding rects for each section.
	   * @param {number} viewportHeight Viewport height.
	   */
	  _findVisiblePosters: function _findVisiblePosters(boundingRects, viewportHeight) {
	    var sections = this.state.sections,
	        visiblePosters = [],
	        section,
	        rect,
	        isPoster,
	        isCoverBeforePoster,
	        i;

	    for (i = 0; i < sections.length; i++) {
	      if (!boundingRects[i]) {
	        continue;
	      }

	      section = sections[i];
	      rect = boundingRects[i];

	      if (rect.bottom <= 0 || rect.top >= viewportHeight || rect.height === 0) {
	        continue;
	      }

	      isPoster = section.type === SectionTypes.POSTER;
	      isCoverBeforePoster = i === 0 && sections.length > 1 && sections[1].type === SectionTypes.POSTER;

	      if (isPoster || isCoverBeforePoster) {
	        visiblePosters.push({
	          index: i,
	          section: section,
	          rect: rect
	        });
	      }
	    }

	    return visiblePosters;
	  },

	  /**
	   * Makes a guess at section bounding rects based on their heights and scroll position.
	   *
	   * This method doesn't actually call `getBoundingClientRect` for performance
	   * reasons so it will break if there are margins between sections.
	   *
	   * @param {array<number>} sectionHeights Heights for each section.
	   * @param {number} scrollY Current scroll position.
	   */
	  _getBoundingRects: function _getBoundingRects(sectionHeights, scrollY) {
	    var accumulatedScrollY = 0,
	        boundingRects = new Array(sectionHeights.length),
	        height;

	    for (var i = 0; i < sectionHeights.length; i++) {
	      height = sectionHeights[i] || 0;

	      boundingRects[i] = {
	        top: accumulatedScrollY - scrollY,
	        bottom: accumulatedScrollY - scrollY + height,
	        height: height
	      };

	      accumulatedScrollY += height;
	    }

	    return boundingRects;
	  }
	};

	module.exports = FadingCalculatorMixin;

/***/ },

/***/ 258:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var update = __webpack_require__(49);
	var _ = __webpack_require__(4);
	var vendorPrefix = __webpack_require__(301);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;

	var isIE10 = _require.isIE10;
	var LightboxActionCreators = __webpack_require__(249);
	var KeyCodes = __webpack_require__(145);

	// Keep this synced with zindexes.less
	var LIGHTBOX_IMAGE_Z = 250;

	/**
	 * Manages lightbox state for a list of images.
	 *
	 * Provides methods to find out if image is currently in the lightbox,
	 * and what styles it needs in order to become visible in the viewport.
	 *
	 * Call `handleLightboxTransitionEnd` whenever lightbox transition ends.
	 *
	 * An easy way to do that would be to use `Image`s in place of `img`s
	 * and set `onTransitionEnd={this.handleLightboxTransitionEnd}` on them.
	 */
	var LightboxMixin = {
	  getInitialState: function getInitialState() {
	    return this.getInitialLightboxState();
	  },

	  getInitialLightboxState: function getInitialLightboxState() {
	    return {
	      lightbox: {
	        current: null,
	        previous: null
	      }
	    };
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    var previousLightbox = prevState.lightbox.current,
	        hasChanged = !_.isEqual(previousLightbox, this.state.lightbox.current);

	    if (!hasChanged) {
	      return;
	    }

	    if (this.isInLightbox()) {
	      window.addEventListener('scroll', this.hideLightbox, false);
	      window.addEventListener('resize', this.hideLightbox, false);
	      window.addEventListener('keydown', this._handleEscapeKeyDown, false);
	    } else {
	      window.removeEventListener('scroll', this.hideLightbox, false);
	      window.removeEventListener('resize', this.hideLightbox, false);
	      window.removeEventListener('keydown', this._handleEscapeKeyDown, false);
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('scroll', this.hideLightbox, false);
	    window.removeEventListener('resize', this.hideLightbox, false);
	    window.removeEventListener('keydown', this._handleEscapeKeyDown, false);

	    if (this.isLightboxVisible()) {
	      LightboxActionCreators.hideLightbox();
	    }
	  },

	  /**
	   * Restores the lightbox to its original state.
	   */
	  resetLightbox: function resetLightbox() {
	    this.setState(this.getInitialLightboxState());

	    if (this.isLightboxVisible()) {
	      LightboxActionCreators.hideLightbox();
	    }
	  },

	  /**
	   * Call this method to let lightbox know the transition is over.
	   *
	   * An easy way to do that would be to use `Image`s in place of `img`s
	   * and set `onTransitionEnd={this.handleLightboxTransitionEnd}` on them.
	   */
	  handleLightboxTransitionEnd: function handleLightboxTransitionEnd() {
	    this._setLightboxState('previous', null);
	  },

	  /**
	   * Closes lightbox on Escape button.
	   */
	  _handleEscapeKeyDown: function _handleEscapeKeyDown(e) {
	    if (e.keyCode === KeyCodes.ESCAPE) {
	      this.hideLightbox();
	    }
	  },

	  /**
	   * Returns 'active' if lightbox is active, 'leaving' if it is being animated away, or false.
	   *
	   * @param {Number?} sectionIndex Optionally, ask about specific section.
	   * @returns {String?}
	   */
	  getLightboxState: function getLightboxState(sectionIndex) {
	    if (this.isInLightbox(sectionIndex)) {
	      return 'active';
	    }

	    if (this.isLeavingLightbox(sectionIndex)) {
	      return 'leaving';
	    }
	  },

	  /**
	   * Returns true if lightbox is visible, false otherwise.
	   *
	   * @param {Number?} sectionIndex Optionally, ask about specific section.
	   * @returns {Boolean}
	   */
	  isLightboxVisible: function isLightboxVisible(sectionIndex) {
	    return !!this.getLightboxState(sectionIndex);
	  },

	  /**
	   * Returns whether lightbox is currently active.
	   *
	   * @param {Number?} sectionIndex Optionally, ask about specific section.
	   * @returns {Boolean}
	   */
	  isInLightbox: function isInLightbox(sectionIndex) {
	    var current = this.state.lightbox.current;
	    if (!current) {
	      return false;
	    }

	    return _.isUndefined(sectionIndex) || current.sectionIndex === sectionIndex;
	  },

	  /**
	   * Returns whether lightbox is currently being animated away.
	   *
	   * @param {Number?} sectionIndex Optionally, ask about specific section.
	   * @returns {Boolean}
	   */
	  isLeavingLightbox: function isLeavingLightbox(sectionIndex) {
	    var previous = this.state.lightbox.previous;
	    if (!previous) {
	      return false;
	    }

	    return _.isUndefined(sectionIndex) || previous.sectionIndex === sectionIndex;
	  },

	  /**
	   * Returns whether a given image is displayed in lightbox.
	   *
	   * @param {ImageMedia} image
	   */
	  isImageInLightbox: function isImageInLightbox(image) {
	    return this.isInLightbox() && this.state.lightbox.current.image.uuid === image.uuid;
	  },

	  /**
	   * Returns whether image with given index is being animated away from the lightbox.
	   *
	   * @param {ImageMedia} image
	   */
	  isImageLeavingLightbox: function isImageLeavingLightbox(image) {
	    return this.isLeavingLightbox() && this.state.lightbox.previous.image.uuid === image.uuid;
	  },

	  /**
	   * If lightbox is active, closes it.
	   * Otherwise, shows lightbox for a given image.
	   *
	   * Provide `fromRect` so `getLightboxImageStyle` knows
	   * how to calculate the transform that animates image into view.
	   *
	   * @param {number} sectionIndex Section index.
	   * @param {SectionType} sectionType Section type.
	   * @param {ImageMedia} image Image, later to be provided in `getLightboxImageStyle`.
	   * @param {object} fromRect Current image position on the page.
	   * @param {number?} toHeight Target container height. Window height if unspecified.
	   */
	  toggleLightbox: function toggleLightbox(sectionIndex, sectionType, image, fromRect, toHeight) {
	    if (this.isInLightbox()) {
	      this.hideLightbox();
	    } else {
	      this.showLightbox(sectionIndex, sectionType, image, fromRect, toHeight);
	    }
	  },

	  isLightboxEnabled: function isLightboxEnabled() {
	    return !isMobile() && !isIE10() && window.matchMedia('(min-width: 992px)').matches;
	  },

	  /**
	   * Shows lightbox for a given image.
	   *
	   * Provide `fromRect` so `getLightboxImageStyle` knows
	   * how to calculate the transform that animates image into view.
	   *
	   * @param {number} sectionIndex Section index.
	   * @param {SectionType} sectionType Section type.
	   * @param {ImageMedia} image Image later to be queried via `getLightboxImageStyle`.
	   * @param {object} fromRect Current image position on the page.
	   * @param {number?} toHeight Target container height. Window height if unspecified.
	   */
	  showLightbox: function showLightbox(sectionIndex, sectionType, image, fromRect, toHeight) {
	    if (!this.isLightboxEnabled()) {
	      return;
	    }

	    this._setLightboxState('current', {
	      sectionIndex: sectionIndex,
	      sectionType: sectionType,
	      image: image,
	      fromRect: fromRect,
	      toHeight: toHeight || window.innerHeight
	    });

	    LightboxActionCreators.showLightbox(image, sectionType);
	  },

	  /**
	   * Hides lightbox.
	   */
	  hideLightbox: function hideLightbox() {
	    if (!this.isInLightbox()) {
	      return;
	    }

	    this._setLightboxState('current', null);

	    LightboxActionCreators.hideLightbox();
	  },

	  /**
	   * Gets CSS style that needs to be applied to
	   * any image in lightbox-enabled gallery, whether
	   * the image is active or not.
	   *
	   * @param {ImageMedia} image Image previously provided in `showLightbox`.
	   */
	  getLightboxImageStyle: function getLightboxImageStyle(image) {
	    var transform = this.getLightboxImageTransform(image),
	        style = {};

	    style[vendorPrefix.js + 'Transform'] = transform;

	    if (this.isImageInLightbox(image) || this.isImageLeavingLightbox(image)) {
	      style.position = 'relative';
	      style.zIndex = LIGHTBOX_IMAGE_Z;
	    }

	    return style;
	  },

	  /**
	   * Gets CSS transform that needs to be applied to
	   * any image in lightbox-enabled gallery, whether
	   * the image is active or not.
	   *
	   * Assumes that when lightbox is active, `state.lightbox.current.fromRect`
	   * matches image initial position just before lightbox was activated.
	   *
	   * @param {ImageMedia} image Image previously provided in `showLightbox`.
	   */
	  getLightboxImageTransform: function getLightboxImageTransform(image) {
	    if (!this.isImageInLightbox(image)) {
	      return 'translate(0, 0) scale(1)';
	    }

	    var origSize = image.size;var _state$lightbox$current = this.state.lightbox.current;
	    var fromRect = _state$lightbox$current.fromRect;

	    var toHeight = _state$lightbox$current.toHeight;
	    var toWidth = window.innerWidth;
	    var leftGap = 16;
	    var rightGap = 16;
	    var topGap = 16;
	    var bottomGap = 68;
	    var availableWidth = toWidth - (leftGap + rightGap);
	    var availableHeight = toHeight - (topGap + bottomGap);
	    var widthRatio = origSize.width / fromRect.width;
	    var scale;

	    if (origSize.width < availableWidth && origSize.height < availableHeight) {
	      scale = widthRatio;
	    } else if (origSize.width / origSize.height < availableWidth / availableHeight) {
	      scale = availableHeight / origSize.height * widthRatio;
	    } else {
	      scale = availableWidth / origSize.width * widthRatio;
	    }

	    var horizontalGapAdjustment = (rightGap - leftGap) / 2,
	        verticalGapAdjustment = (topGap - bottomGap) / 2,
	        left = (toWidth - fromRect.width) / 2 - fromRect.left + horizontalGapAdjustment,
	        top = (toHeight - fromRect.height) / 2 - fromRect.top + verticalGapAdjustment,
	        transform = 'translate(' + left + 'px, ' + top + 'px) scale(' + scale + ')';

	    return transform;
	  },

	  _setLightboxState: function _setLightboxState(key, value) {
	    var stateUpdate = {};

	    stateUpdate[key] = {
	      $set: value
	    };

	    if (key === 'current' && value === null) {
	      var current = this.state.lightbox.current;
	      stateUpdate['previous'] = {
	        $set: current
	      };
	    }

	    this._updateState({
	      lightbox: stateUpdate
	    });
	  },

	  _updateState: function _updateState(stateUpdate) {
	    if (!this.isMounted()) {
	      return;
	    }

	    this.replaceState(update(this.state, stateUpdate));
	  }
	};

	module.exports = LightboxMixin;

/***/ },

/***/ 261:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var AnchorScrollMixin = __webpack_require__(255);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;

	/**
	 * Listens to `keydown` and `keyup` events and provides snapping
	 * on space press.
	 */
	var StampScrollMixin = {
	  mixins: [AnchorScrollMixin],

	  propTypes: {
	    isInViewer: React.PropTypes.bool.isRequired
	  },

	  componentDidMount: function componentDidMount() {
	    if (isMobile()) {
	      return;
	    }

	    window.addEventListener('keydown', this._handleKeyDown);
	    window.addEventListener('keyup', this._handleKeyUp);
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    if (isMobile()) {
	      return;
	    }

	    window.removeEventListener('keydown', this._handleKeyDown);
	    window.removeEventListener('keyup', this._handleKeyUp);
	  },

	  _handleKeyDown: function _handleKeyDown(e) {
	    if (!this.isSpaceKeyEvent(e) || !this.isMounted()) {
	      return;
	    }

	    this.handleSpaceKeyDown(e);
	  },

	  _handleKeyUp: function _handleKeyUp(e) {
	    if (!this.isSpaceKeyEvent(e) || !this.isMounted()) {
	      return;
	    }

	    this.handleSpaceKeyUp(e);
	  }
	};

	module.exports = StampScrollMixin;

/***/ },

/***/ 264:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var Icon = __webpack_require__(10);var PropTypes = React.PropTypes;

	__webpack_require__(333);

	var ImageUsageCounter = React.createClass({
	  displayName: 'ImageUsageCounter',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    counter: PropTypes.number.isRequired
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.getClassName() },
	      React.createElement(Icon, { name: 'collect',
	        mode: 'stroke',
	        size: 'xsmall' }),
	      React.createElement(
	        'span',
	        { className: 'ImageUsageCounter-count' },
	        this.props.counter
	      )
	    );
	  }
	});

	module.exports = ImageUsageCounter;

/***/ },

/***/ 269:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var classSet = __webpack_require__(163);
	var PropTypes = React.PropTypes;
	var formatTime = __webpack_require__(136);
	var PureRenderMixin = __webpack_require__(2);

	__webpack_require__(334);

	var TrackList = React.createClass({
	  displayName: 'TrackList',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    tracks: PropTypes.array.isRequired,
	    activeTrackIndex: PropTypes.number.isRequired,
	    isPlaying: PropTypes.bool.isRequired,
	    onSelect: PropTypes.func.isRequired
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.isPlaying && 'active'];
	  },

	  render: function render() {
	    return React.createElement(
	      'ul',
	      { className: 'TrackList' },
	      this.renderTracks()
	    );
	  },

	  renderTracks: function renderTracks() {
	    var _this = this;

	    var activeTrackIndex = this.props.activeTrackIndex;

	    return this.props.tracks.map(function (track, index) {
	      return React.createElement(
	        'li',
	        { className: classSet({
	            'TrackList-track': true,
	            'TrackList-track--active': index === activeTrackIndex
	          }),
	          onClick: _this.handleSelect.bind(_this, index),
	          key: index },
	        React.createElement(
	          'span',
	          { className: 'TrackList-trackTitle' },
	          track.title
	        ),
	        React.createElement(
	          'span',
	          { className: 'TrackList-trackDuration' },
	          formatTime(track.duration)
	        )
	      );
	    });
	  },

	  handleSelect: function handleSelect(index) {
	    this.props.onSelect(index);
	  }
	});

	module.exports = TrackList;

/***/ },

/***/ 274:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var PlayerStore = __webpack_require__(119);
	var PlayerActionCreators = __webpack_require__(84);
	var AudioCover = __webpack_require__(170);
	var TrackList = __webpack_require__(269);
	var PureRenderMixin = __webpack_require__(2);
	var DefaultAudioImage = __webpack_require__(144);
	var AudioContainer = __webpack_require__(173);
	var MediaTypes = __webpack_require__(70);var PropTypes = React.PropTypes;

	var AudioPlayList = React.createClass({
	  displayName: 'AudioPlayList',

	  mixins: [createStoreMixin(PlayerStore), PureRenderMixin],

	  propTypes: {
	    uuid: PropTypes.string.isRequired,
	    url: PropTypes.string.isRequired,
	    tracks: PropTypes.array.isRequired,
	    title: PropTypes.string.isRequired,
	    background: PropTypes.object,
	    stamp: PropTypes.shape({
	      id: PropTypes.number
	    }).isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    var mediaId = this.props.uuid;

	    return {
	      isPlaying: PlayerStore.isPlaying(mediaId),
	      isPaused: PlayerStore.isPaused(mediaId),
	      activeTrackIndex: PlayerStore.getActiveTrackIndex(mediaId),
	      activeTrack: PlayerStore.getActiveTrack(mediaId),
	      currentTime: PlayerStore.getCurrentTime(mediaId),
	      artwork: PlayerStore.getArtwork(mediaId)
	    };
	  },

	  componentWillMount: function componentWillMount() {
	    PlayerActionCreators.registerAudio(this.props.uuid, {
	      mediaType: MediaTypes.AUDIO_PLAYLIST,
	      tracks: this.props.tracks,
	      background: this.props.background,
	      stampId: this.props.stamp.id
	    });
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    PlayerActionCreators.unregisterAudio(this.props.uuid);
	  },

	  getBackground: function getBackground() {
	    return this.props.background || DefaultAudioImage;
	  },

	  getArtwork: function getArtwork() {
	    return this.state.artwork || DefaultAudioImage;
	  },

	  getTrackDuration: function getTrackDuration(track) {
	    return track && track.duration || 0;
	  },

	  renderCover: function renderCover() {
	    var _state = this.state;
	    var isPlaying = _state.isPlaying;
	    var activeTrack = _state.activeTrack;
	    var currentTime = _state.currentTime;
	    var isPaused = _state.isPaused;

	    return React.createElement(AudioCover, { uuid: this.props.uuid,
	      linkUrl: this.props.url,
	      colors: this.getBackground().colors,
	      artwork: this.getArtwork(),
	      duration: this.getTrackDuration(activeTrack),
	      currentTime: currentTime,
	      isPlaying: isPlaying,
	      isPaused: isPaused,
	      onBackward: this.handleBackward,
	      onForward: this.handleForward,
	      onPlay: this.togglePause,
	      onPause: this.togglePause,
	      alwaysShowControls: true });
	  },

	  renderTrackList: function renderTrackList() {
	    return React.createElement(TrackList, { tracks: this.props.tracks,
	      activeTrackIndex: this.state.activeTrackIndex,
	      isPlaying: this.state.isPlaying,
	      onSelect: this.toggleTrack });
	  },

	  render: function render() {
	    return React.createElement(AudioContainer, { title: this.props.title,
	      username: this.props.username,
	      duration: this.props.duration,
	      background: this.getBackground(),
	      url: this.props.url,
	      cover: this.renderCover(),
	      trackList: this.renderTrackList() });
	  },

	  togglePause: function togglePause() {
	    var mediaId = this.props.uuid;

	    if (this.state.isPlaying) {
	      PlayerActionCreators.pause(mediaId);
	    } else {
	      PlayerActionCreators.play(mediaId);
	    }
	  },

	  toggleTrack: function toggleTrack(index) {
	    if (this.state.activeTrackIndex === index) {
	      this.togglePause();
	    } else {
	      PlayerActionCreators.play(this.props.uuid, {
	        trackIndex: index,
	        currentTime: 0
	      });
	    }
	  },

	  handleBackward: function handleBackward() {
	    PlayerActionCreators.playPrevious(this.props.uuid);
	  },

	  handleForward: function handleForward() {
	    PlayerActionCreators.playNext(this.props.uuid);
	  }
	});

	module.exports = AudioPlayList;

/***/ },

/***/ 275:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var PlayerStore = __webpack_require__(119);
	var PlayerActionCreators = __webpack_require__(84);
	var AudioCover = __webpack_require__(170);
	var AudioContainer = __webpack_require__(173);
	var DefaultAudioImage = __webpack_require__(144);
	var PureRenderMixin = __webpack_require__(2);
	var MediaTypes = __webpack_require__(70);var PropTypes = React.PropTypes;

	var AudioTrack = React.createClass({
	  displayName: 'AudioTrack',

	  mixins: [createStoreMixin(PlayerStore), PureRenderMixin],

	  propTypes: {
	    uuid: PropTypes.string.isRequired,
	    source: PropTypes.string,
	    background: PropTypes.object,
	    streamUrl: PropTypes.string,
	    url: PropTypes.string.isRequired,
	    stamp: PropTypes.shape({
	      id: PropTypes.number
	    }).isRequired
	  },

	  getStateFromStores: function getStateFromStores() {
	    var mediaId = this.props.uuid;

	    return {
	      isPlaying: PlayerStore.isPlaying(mediaId),
	      isPaused: PlayerStore.isPaused(mediaId),
	      currentTime: PlayerStore.getCurrentTime(mediaId),
	      artwork: PlayerStore.getArtwork(mediaId)
	    };
	  },

	  componentWillMount: function componentWillMount() {
	    PlayerActionCreators.registerAudio(this.props.uuid, {
	      mediaType: MediaTypes.AUDIO_PLAYLIST,
	      background: this.props.background,
	      tracks: [this.props],
	      trackIndex: 0,
	      stampId: this.props.stamp.id
	    });
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    PlayerActionCreators.unregisterAudio(this.props.uuid);
	  },

	  getArtwork: function getArtwork() {
	    return this.state.artwork || DefaultAudioImage;
	  },

	  getBackground: function getBackground() {
	    return this.props.background || DefaultAudioImage;
	  },

	  renderCover: function renderCover() {
	    var _state = this.state;
	    var isPlaying = _state.isPlaying;
	    var currentTime = _state.currentTime;
	    var isPaused = _state.isPaused;var _props = this.props;
	    var url = _props.url;
	    var duration = _props.duration;

	    return React.createElement(AudioCover, { uuid: this.props.uuid,
	      linkUrl: url,
	      artwork: this.getArtwork(),
	      colors: this.getBackground().colors,
	      duration: duration,
	      currentTime: currentTime,
	      isPlaying: isPlaying,
	      isPaused: isPaused,
	      onPlay: this.togglePause,
	      onPause: this.togglePause,
	      onBackward: this.handleBackward,
	      onForward: this.handleForward,
	      context: 'AudioTrack' });
	  },

	  render: function render() {
	    return React.createElement(AudioContainer, { title: this.props.title,
	      username: this.props.username,
	      duration: this.props.duration,
	      background: this.getBackground(),
	      url: this.props.url,
	      cover: this.renderCover() });
	  },

	  togglePause: function togglePause() {
	    var isPlaying = this.state.isPlaying,
	        mediaId = this.props.uuid;

	    if (isPlaying) {
	      PlayerActionCreators.pause(mediaId);
	    } else {
	      PlayerActionCreators.play(mediaId);
	    }
	  },

	  handleBackward: function handleBackward() {
	    PlayerActionCreators.playPrevious(this.props.uuid);
	  },

	  handleForward: function handleForward() {
	    PlayerActionCreators.playNext(this.props.uuid);
	  }
	});

	module.exports = AudioTrack;

/***/ },

/***/ 276:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    ResponsiveImageQueueMixin = __webpack_require__(86),
	    PureRenderMixin = __webpack_require__(2),
	    Analytics = __webpack_require__(52),
	    AnalyticsEvents = __webpack_require__(55);

	__webpack_require__(38);
	__webpack_require__(336);

	var COVER = {
	  url: '//stampsy-eu-1.s3.amazonaws.com/uploads/12/19/2014/be92ae37-d8d1-4d4b-afaf-0926d28a6e25.jpg',
	  size: {
	    width: 1024,
	    height: 1024
	  }
	};

	var BuyInItunes = React.createClass({
	  displayName: 'BuyInItunes',

	  mixins: [ResponsiveImageQueueMixin, PureRenderMixin],

	  getImageOptions: function getImageOptions() {
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    return {
	      image: COVER,
	      mode: 'scale_crop',
	      sizes: {
	        normal: true,
	        retina: devicePixelRatio > 1.5
	      }
	    };
	  },

	  getImageSizes: function getImageSizes() {
	    return {
	      'default': 400,
	      'xs': 560,
	      'sm': 192,
	      'md': 192,
	      'lg': 192,
	      'xl': 192
	    };
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'stamp-BuyInItunes',
	        'data-scroll-anchor': true },
	      React.createElement(
	        'div',
	        { className: 'stamp-BuyInItunes-box' },
	        React.createElement(
	          'div',
	          { className: 'stamp-BuyInItunes-label' },
	          'iTunes Store'
	        ),
	        this.renderLoaderImg(),
	        React.createElement(
	          'div',
	          { className: 'stamp-BuyInItunes-cover', style: { backgroundImage: this.getBackgroundImageUrl() } },
	          React.createElement('a', { className: 'stamp-BuyInItunes-coverLink',
	            href: 'https://itunes.apple.com/ru/album/planetarium/id952188951?uo=4',
	            target: '_blank',
	            onClick: this.handleClick })
	        ),
	        React.createElement(
	          'div',
	          { className: 'stamp-BuyInItunes-meta' },
	          React.createElement(
	            'a',
	            { className: 'stamp-BuyInItunes-title Link Link--underlineHover',
	              href: 'https://itunes.apple.com/ru/album/planetarium/id952188951?uo=4',
	              target: '_blank',
	              onClick: this.handleClick },
	            'Planetarium'
	          ),
	          React.createElement(
	            'div',
	            { className: 'stamp-BuyInItunes-artist' },
	            'Mujuice'
	          ),
	          React.createElement(
	            'a',
	            { className: 'Btn Btn--green Btn--medium Btn--fill stamp-BuyInItunes-button',
	              href: 'https://itunes.apple.com/ru/album/planetarium/id952188951?uo=4',
	              target: '_blank',
	              onClick: this.handleClick },
	            'View in iTunes'
	          )
	        )
	      )
	    );
	  },

	  handleClick: function handleClick() {
	    Analytics.trackEvent(AnalyticsEvents.STAMP_ACTION_BUY_IN_ITUNES);
	  }
	});

	module.exports = BuyInItunes;
	/**
	 * Note: use <a> instead of <Link> and <Button>
	 * because our elements don't trigger onClick
	 * with target="_blank" and we don't want to special
	 * case them yet. If we later need this, we'll
	 * revisit this part.
	 */

/***/ },

/***/ 277:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _extends = __webpack_require__(27)['default'];

	var React = __webpack_require__(1);
	var gradient = __webpack_require__(123);
	var StampImageMixin = __webpack_require__(130);
	var PureRenderMixin = __webpack_require__(2);
	var ClassNameMixin = __webpack_require__(3);
	var Img = __webpack_require__(127);
	var Loader = __webpack_require__(43);
	var FontTest = __webpack_require__(92);
	var ZineLink = __webpack_require__(93);
	var SectionTypes = __webpack_require__(40);
	var getScrollY = __webpack_require__(82);
	var isBestOf2014Special = __webpack_require__(83);
	var waitForElasticScroll = __webpack_require__(222);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;var PropTypes = React.PropTypes;

	__webpack_require__(38);
	__webpack_require__(337);

	function stopPropagation(e) {
	  e.stopPropagation();
	}

	var DEFAULT_BACKGROUND = {
	  colors: {
	    top: 'FFFFFF',
	    bottom: 'FFFFFF'
	  }
	};

	var Cover = React.createClass({
	  displayName: 'Cover',

	  mixins: [PureRenderMixin, StampImageMixin, ClassNameMixin],

	  className: 'stamp-Cover',

	  propTypes: {
	    stamp: PropTypes.object.isRequired,
	    isInViewer: PropTypes.bool.isRequired,
	    isLoading: PropTypes.bool,
	    sectionIndex: PropTypes.number.isRequired,
	    isLightboxEnabled: PropTypes.func.isRequired,
	    primaryZine: PropTypes.object
	  },

	  getDefaultProps: function getDefaultProps() {
	    return {
	      allowEmpty: true
	    };
	  },

	  getImageSizes: function getImageSizes() {
	    return {
	      'default': 480,
	      'xs': 640,
	      'sm': 992,
	      'md': 1200,
	      'lg': 1440,
	      'xl': 1600
	    };
	  },

	  getInitialState: function getInitialState() {
	    return {
	      isAtTop: getScrollY() <= 0,
	      imageWrapperStyle: {}
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    return {
	      clickable: this.shouldOpenLightboxOnClick()
	    };
	  },

	  getImage: function getImage(props) {
	    var stamp = props.stamp;
	    var background;

	    if (stamp.content) {
	      background = stamp.content.sections[0].background;
	    }

	    return background || stamp.thumbnail || DEFAULT_BACKGROUND;
	  },

	  shouldOpenLightboxOnClick: function shouldOpenLightboxOnClick() {
	    var isLightboxEnabled = this.props.isLightboxEnabled();
	    var image = this.getImage(this.props);var isAtTop = this.state.isAtTop;

	    return isLightboxEnabled && isAtTop && image !== DEFAULT_BACKGROUND;
	  },

	  preventClicksIfLightboxEnabled: function preventClicksIfLightboxEnabled() {
	    if (!this.shouldOpenLightboxOnClick()) {
	      return;
	    }

	    return {
	      onClick: stopPropagation,
	      style: {
	        cursor: 'default'
	      }
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    this.deferUpdateWrapperStyle = window.setTimeout.bind(window, this.updateWrapperStyle, 0);

	    window.addEventListener('scroll', this.handleWindowScroll, false);
	    window.addEventListener('resize', this.updateWrapperStyle, false);
	    window.addEventListener('orientationchange', this.deferUpdateWrapperStyle, false);

	    this.updateWrapperStyle();
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('scroll', this.handleWindowScroll, false);
	    window.removeEventListener('resize', this.updateWrapperStyle, false);
	    window.removeEventListener('orientationchange', this.deferUpdateWrapperStyle, false);
	  },

	  updateWrapperStyle: function updateWrapperStyle() {
	    if (!this.isMounted()) {
	      return;
	    }

	    var coverEl = this.getDOMNode(),
	        coverWidth = window.innerWidth,
	        coverHeight = coverEl.offsetHeight,
	        image = this.getImage(this.props),
	        originalSize = image.size || {},
	        imageHeight = Math.round(coverWidth * (originalSize.height / originalSize.width)) + 1,
	        widthScale = Math.max(1, coverHeight / imageHeight);

	    this.setState({
	      imageWrapperStyle: {
	        width: widthScale * 100 + '%',
	        left: (1 - widthScale) / 2 * 100 + '%'
	      }
	    });
	  },

	  handleWindowScroll: function handleWindowScroll() {
	    if (!this.isMounted()) {
	      return;
	    }

	    var scrollY = getScrollY(),
	        isAtTop = scrollY <= 0;

	    this.setState({
	      isAtTop: isAtTop
	    });
	  },

	  render: function render() {
	    var _props = this.props;
	    var stamp = _props.stamp;
	    var primaryZine = _props.primaryZine;
	    var isLoading = _props.isLoading;
	    var subtitle = stamp.description;
	    var background = this.getImage(this.props);
	    var colors = background.colors;
	    var isDesktop = !isMobile();
	    var hasLoadedImage = this.hasLoadedImage();
	    var imageStyle = this.props.getLightboxImageStyle(background);
	    var style;

	    if (isDesktop || !hasLoadedImage) {
	      style = {
	        backgroundImage: gradient('#' + colors.top, '#' + colors.bottom)
	      };
	    }

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        style: style,
	        'data-lightbox': this.props.lightboxState,
	        'data-scroll-anchor': true,
	        onClick: this.handleClick },
	      React.createElement(
	        'div',
	        { className: 'stamp-Cover-imgWrapper',
	          style: this.state.imageWrapperStyle },
	        React.createElement(Img, { src: this.getImageSrcUrl(),
	          ref: 'image',
	          className: 'stamp-Cover-img',
	          style: imageStyle,
	          onTransitionEnd: this.handleImageTransitionEnd,
	          onLoad: this.handleImageLoad,
	          onError: this.handleImageError })
	      ),
	      isLoading && React.createElement(Loader, null),
	      !isLoading && React.createElement(
	        'div',
	        { className: 'stamp-Cover-box' },
	        isBestOf2014Special(primaryZine) && React.createElement(
	          ZineLink,
	          { zine: primaryZine,
	            className: 'stamp-Cover-bestOf2014',
	            underline: 'never',
	            showTitle: true },
	          'Best of 2014'
	        ),
	        React.createElement(
	          'h1',
	          _extends({ className: 'stamp-Cover-title'
	          }, this.preventClicksIfLightboxEnabled()),
	          stamp.title
	        ),
	        subtitle && React.createElement(
	          FontTest,
	          { family: 'minion-pro-condensed',
	            test: subtitle },
	          React.createElement('h3', _extends({ className: 'stamp-Cover-subtitle',
	            dangerouslySetInnerHTML: { __html: subtitle }
	          }, this.preventClicksIfLightboxEnabled()))
	        )
	      ),
	      this.renderUsageCounter(),
	      this.renderAttributionOnMobile()
	    );
	  },

	  handleClick: function handleClick(e) {
	    this.toggleAttributionOnMobile(e);

	    if (this.shouldOpenLightboxOnClick()) {
	      this.toggleLightbox();
	    }
	  },

	  handleImageTransitionEnd: function handleImageTransitionEnd() {
	    if (this.props.onImageTransitionEnd) {
	      this.props.onImageTransitionEnd();
	    }
	  },

	  toggleLightbox: function toggleLightbox() {
	    var _this = this;

	    waitForElasticScroll().then(function () {
	      if (!_this.isMounted()) {
	        return;
	      }

	      var boundingRect = _this.refs.image.getDOMNode().getBoundingClientRect(),
	          toHeight = _this.getDOMNode().offsetHeight,
	          background = _this.getImage(_this.props);

	      _this.props.toggleLightbox(_this.props.sectionIndex, SectionTypes.COVER, background, boundingRect, toHeight);
	    });
	  }
	});

	module.exports = Cover;

/***/ },

/***/ 278:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    TransitionEventsMixin = __webpack_require__(167),
	    PureRenderMixin = __webpack_require__(2),
	    ClassNameMixin = __webpack_require__(3);

	__webpack_require__(38);
	__webpack_require__(338);

	var Fade = React.createClass({
	  displayName: 'Fade',

	  mixins: [ClassNameMixin, TransitionEventsMixin, PureRenderMixin],

	  propTypes: {
	    color: React.PropTypes.string.isRequired,
	    opacity: React.PropTypes.number.isRequired,
	    isActive: React.PropTypes.bool.isRequired,
	    isVisible: React.PropTypes.bool.isRequired,
	    isLightboxVisible: React.PropTypes.bool.isRequired,
	    isTop: React.PropTypes.bool
	  },

	  className: 'stamp-Fade',

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.isTop && 'top'];
	  },

	  getInitialState: function getInitialState() {
	    return {
	      animateOpacity: false
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var lightboxChanged = newProps.isLightboxVisible !== this.props.isLightboxVisible,
	        activeChanged = newProps.isActive !== this.props.isActive,
	        visibleChanged = newProps.isVisible !== this.props.isVisible,
	        dOpacity = Math.abs(newProps.opacity - this.props.opacity);

	    if (lightboxChanged || activeChanged && !visibleChanged && dOpacity > 0) {
	      this.setState({
	        animateOpacity: true
	      });
	    }
	  },

	  handleTransitionEnd: function handleTransitionEnd() {
	    this.setState({
	      animateOpacity: false
	    });
	  },

	  render: function render() {
	    var opacity = this.getOpacity(),
	        style;

	    style = {
	      pointerEvents: opacity < 1 ? 'none' : '',
	      opacity: opacity,
	      backgroundColor: '#' + this.props.color
	    };

	    return React.createElement('div', { className: this.getClassName(),
	      'data-animate': this.state.animateOpacity,
	      style: style });
	  },

	  getOpacity: function getOpacity() {
	    if (this.props.isLightboxVisible) {
	      return 1;
	    }

	    // Chrome gets stuck at 0 opacity sometimes
	    return this.props.opacity || 0.00001;
	  }
	});

	module.exports = Fade;

/***/ },

/***/ 279:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    GalleryImage = __webpack_require__(174),
	    PureRenderMixin = __webpack_require__(2),
	    SectionTypes = __webpack_require__(40);

	__webpack_require__(38);
	__webpack_require__(340);

	var IMAGE_SIZES = {
	  'default': 480,
	  'xs': 512,
	  'sm': 512,
	  'md': 512,
	  'lg': 512,
	  'xl': 640
	};

	var ITEMS_IN_ROW = 2;

	var GridGallery = React.createClass({
	  displayName: 'GridGallery',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    stamp: React.PropTypes.object.isRequired,
	    images: React.PropTypes.array.isRequired,
	    sectionIndex: React.PropTypes.number.isRequired,
	    lightboxState: React.PropTypes.oneOf(['active', 'leaving']),
	    toggleLightbox: React.PropTypes.func.isRequired,
	    getLightboxImageStyle: React.PropTypes.func.isRequired,
	    isImageInLightbox: React.PropTypes.func.isRequired,
	    onImageTransitionEnd: React.PropTypes.func.isRequired
	  },

	  getImageSizes: function getImageSizes() {
	    return IMAGE_SIZES;
	  },

	  getRows: function getRows() {
	    var images = this.props.images;
	    var rows = [];

	    for (var i = 0; i < images.length; i += ITEMS_IN_ROW) {
	      rows.push(images.slice(i, i + ITEMS_IN_ROW).filter(Boolean));
	    }

	    return rows;
	  },

	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: 'stamp-GridGallery',
	        'data-lightbox': this.props.lightboxState },
	      React.createElement(
	        'div',
	        { className: 'stamp-GridGallery-box' },
	        this.getRows().map(this.renderRow)
	      )
	    );
	  },

	  renderRow: function renderRow(row, index) {
	    return React.createElement(
	      'div',
	      { className: 'stamp-GridGallery-row', key: index },
	      row.map(this.renderImage)
	    );
	  },

	  renderImage: function renderImage(image, indexInRow, row) {
	    var imageStyle = this.props.getLightboxImageStyle(image),
	        caption = image.caption,
	        galleryStyle = {},
	        siblingImage = indexInRow === 0 ? row[1] : row[0];

	    galleryStyle.flex = 1;
	    galleryStyle.MozFlex = 1;
	    galleryStyle.WebkitFlex = 1;
	    galleryStyle.msFlex = 1;

	    if (siblingImage) {
	      galleryStyle.flex = siblingImage.size.height / siblingImage.size.width;
	      galleryStyle.MozFlex = siblingImage.size.height / siblingImage.size.width;
	      galleryStyle.WebkitFlex = siblingImage.size.height / siblingImage.size.width;
	      galleryStyle.msFlex = siblingImage.size.height / siblingImage.size.width;
	    }

	    return React.createElement(GalleryImage, { key: indexInRow,
	      className: 'stamp-GridGallery-item',
	      style: galleryStyle,
	      stamp: this.props.stamp,
	      image: image,
	      imageSizes: IMAGE_SIZES,
	      imageStyle: imageStyle,
	      caption: caption,
	      onClick: this.handleImageClick,
	      onTransitionEnd: this.props.onImageTransitionEnd,
	      isImageInLightbox: this.props.isImageInLightbox,
	      lightboxState: this.props.lightboxState });
	  },

	  handleImageClick: function handleImageClick(image, e) {
	    var boundingRect = e.target.getBoundingClientRect();
	    this.props.toggleLightbox(this.props.sectionIndex, SectionTypes.GALLERY, image, boundingRect);
	  }
	});

	module.exports = GridGallery;

/***/ },

/***/ 280:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(2);
	var ZineItem = __webpack_require__(273);
	var UserItem = __webpack_require__(272);
	var Container = __webpack_require__(81);
	var Link = __webpack_require__(21);
	var pluralize = __webpack_require__(98);
	var SidebarTypes = __webpack_require__(39);
	var SidebarActionCreators = __webpack_require__(29);
	var formatDate = __webpack_require__(135);
	var createAnalyticsContextMixin = __webpack_require__(169);
	var OffsetMonitor = __webpack_require__(128);
	var AnalyticsSources = __webpack_require__(34);
	var Button = __webpack_require__(13);
	var ScreenSizeMixin = __webpack_require__(71);
	var ShareTypes = __webpack_require__(113);
	var LikeButton = __webpack_require__(265);
	var ShareAddStamp = __webpack_require__(271);var PropTypes = React.PropTypes;

	__webpack_require__(38);
	__webpack_require__(342);

	var InfoPanel = React.createClass({
	  displayName: 'InfoPanel',

	  mixins: [PureRenderMixin, createAnalyticsContextMixin(AnalyticsSources.INFO_PANEL), ScreenSizeMixin],

	  propTypes: {
	    onOffsetTopChange: PropTypes.func,
	    stamp: PropTypes.object.isRequired,
	    user: PropTypes.object.isRequired,
	    primaryZine: PropTypes.object,
	    otherZines: PropTypes.array.isRequired,
	    isInViewer: PropTypes.bool.isRequired,
	    showFeedback: PropTypes.bool,
	    disableInfoPanel: PropTypes.bool
	  },

	  render: function render() {
	    var _props = this.props;
	    var stamp = _props.stamp;
	    var user = _props.user;
	    var primaryZine = _props.primaryZine;
	    var otherZines = _props.otherZines;
	    var isInViewer = _props.isInViewer;
	    var showFeedback = _props.showFeedback;
	    var disableInfoPanel = _props.disableInfoPanel;
	    var isMobile = this.state.isMobile;

	    var published = stamp.published ? new Date(stamp.published) : new Date();
	    var primaryServices = isMobile ? [] : [ShareTypes.FACEBOOK, ShareTypes.TWITTER];

	    return React.createElement(
	      OffsetMonitor,
	      { onOffsetTopChange: this.props.onOffsetTopChange },
	      React.createElement(
	        'div',
	        { className: 'InfoPanel',
	          'data-section': 'info',
	          'data-disabled': disableInfoPanel,
	          'data-scroll-anchor': true },
	        React.createElement(
	          Container,
	          { context: 'InfoPanel' },
	          React.createElement(
	            'div',
	            { className: 'InfoPanel-box' },
	            showFeedback && React.createElement(
	              'div',
	              { className: 'InfoPanel-section InfoPanel-section--feedback' },
	              React.createElement(
	                Button,
	                { color: 'green',
	                  onClick: this.handleFeedbackClick,
	                  active: true },
	                'Leave Feedback'
	              )
	            ),
	            !showFeedback && React.createElement(
	              'div',
	              { className: 'InfoPanel-section InfoPanel-section--buttons' },
	              React.createElement(
	                'div',
	                { className: 'InfoPanel-buttons' },
	                React.createElement(LikeButton, { size: 'xlarge',
	                  iconSize: 'medium',
	                  showCounter: true,
	                  showLikers: isInViewer,
	                  stamp: stamp,
	                  color: 'gray',
	                  fill: true,
	                  like: true }),
	                React.createElement(
	                  'div',
	                  { className: 'InfoPanel-share' },
	                  React.createElement(ShareAddStamp, { size: 'medium',
	                    color: 'gray',
	                    stamp: stamp,
	                    primaryServices: primaryServices,
	                    showAddLabel: true,
	                    round: true })
	                )
	              )
	            )
	          )
	        ),
	        React.createElement(
	          Container,
	          { context: 'InfoPanel' },
	          React.createElement(
	            'div',
	            { className: 'InfoPanel-box' },
	            React.createElement(
	              'div',
	              { className: 'InfoPanel-section InfoPanel-section--userAndZine' },
	              React.createElement(
	                'div',
	                { className: 'InfoPanel-user' },
	                React.createElement(
	                  'div',
	                  { className: 'InfoPanel-label utils--smallCaps' },
	                  'Posted By'
	                ),
	                React.createElement(UserItem, { user: user,
	                  vertical: true,
	                  context: 'InfoPanel',
	                  size: 'small',
	                  imageSize: 'large',
	                  card: true,
	                  showAbout: true,
	                  showLocation: true,
	                  showWebsite: true,
	                  showFollow: true }),
	                React.createElement(
	                  'div',
	                  { className: 'InfoPanel-date' },
	                  'Posted on ',
	                  formatDate(published)
	                )
	              ),
	              primaryZine && React.createElement(
	                'div',
	                { className: 'InfoPanel-zine' },
	                React.createElement(
	                  'div',
	                  { className: 'InfoPanel-label utils--smallCaps' },
	                  'In Collection'
	                ),
	                React.createElement(ZineItem, { zine: primaryZine,
	                  size: 'small',
	                  context: 'InfoPanel' }),
	                React.createElement(
	                  'div',
	                  { className: 'InfoPanel-otherZines' },
	                  otherZines.length > 0 && React.createElement(
	                    'span',
	                    null,
	                    'Also in',
	                    ' ',
	                    React.createElement(
	                      Link,
	                      { onClick: this.handleOtherZinesClick,
	                        underline: 'hover',
	                        bold: true },
	                      otherZines.length,
	                      ' other ',
	                      pluralize(otherZines.length, 'collection', 'collections')
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  },

	  handleFeedbackClick: function handleFeedbackClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.LEAVE_DRAFT_FEEDBACK, {
	      draftUuid: this.props.stamp.uuid
	    });
	  },

	  handleOtherZinesClick: function handleOtherZinesClick() {
	    SidebarActionCreators.showSidebar(SidebarTypes.STAMP_OTHER_ZINES, {
	      stampId: this.props.stamp.id,
	      zineSlugs: this.props.otherZines.map(function (z) {
	        return z.slug;
	      })
	    });
	  }
	});

	module.exports = InfoPanel;

/***/ },

/***/ 281:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    _ = __webpack_require__(4),
	    PureRenderMixin = __webpack_require__(2),
	    ClassNameMixin = __webpack_require__(3),
	    SectionTypes = __webpack_require__(40);

	__webpack_require__(343);

	var LightboxOverlay = React.createClass({
	  displayName: 'LightboxOverlay',

	  mixins: [ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    stamp: React.PropTypes.object.isRequired,
	    image: React.PropTypes.object.isRequired,
	    color: React.PropTypes.oneOf(['dark', 'light']).isRequired,
	    hideLightbox: React.PropTypes.func.isRequired,
	    isInLightbox: React.PropTypes.bool.isRequired,
	    sectionType: React.PropTypes.oneOf([SectionTypes.COVER, SectionTypes.GALLERY, SectionTypes.POSTER]).isRequired
	  },

	  className: 'stamp-LightboxOverlay',

	  getCSSModifiers: function getCSSModifiers() {
	    return [this.props.sectionType];
	  },

	  componentDidMount: function componentDidMount() {
	    _.defer(this._triggerActiveTransition);
	  },

	  componentDidUpdate: function componentDidUpdate() {
	    _.defer(this._triggerActiveTransition);
	  },

	  _triggerActiveTransition: function _triggerActiveTransition() {
	    if (this.isMounted()) {
	      this.getDOMNode().setAttribute('data-active', this.props.isInLightbox);
	    }
	  },

	  render: function render() {
	    return React.createElement('div', { className: this.getClassName(),
	      onClick: this.props.hideLightbox });
	  }
	});

	module.exports = LightboxOverlay;

/***/ },

/***/ 282:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    GalleryImage = __webpack_require__(174),
	    PureRenderMixin = __webpack_require__(2),
	    SectionTypes = __webpack_require__(40);

	__webpack_require__(38);
	__webpack_require__(344);

	var IMAGE_SIZES = {
	  'default': 480,
	  'xs': 640,
	  'sm': 992,
	  'md': 1024,
	  'lg': 1024,
	  'xl': 1280
	};

	var ListGallery = React.createClass({
	  displayName: 'ListGallery',

	  mixins: [PureRenderMixin],

	  propTypes: {
	    stamp: React.PropTypes.object.isRequired,
	    images: React.PropTypes.array.isRequired,
	    sectionIndex: React.PropTypes.number.isRequired,
	    lightboxState: React.PropTypes.oneOf(['active', 'leaving']),
	    toggleLightbox: React.PropTypes.func.isRequired,
	    getLightboxImageStyle: React.PropTypes.func.isRequired,
	    isImageInLightbox: React.PropTypes.func.isRequired,
	    onImageTransitionEnd: React.PropTypes.func.isRequired
	  },

	  getImageSizes: function getImageSizes() {
	    return IMAGE_SIZES;
	  },

	  render: function render() {
	    var images = this.props.images;

	    return React.createElement(
	      'div',
	      { className: 'stamp-ListGallery',
	        'data-lightbox': this.props.lightboxState },
	      React.createElement(
	        'div',
	        { className: 'stamp-ListGallery-box' },
	        images.map(this.renderImage)
	      )
	    );
	  },

	  renderImage: function renderImage(image, index) {
	    var imageStyle = this.props.getLightboxImageStyle(image),
	        caption = image.caption;

	    return React.createElement(GalleryImage, { key: index,
	      stamp: this.props.stamp,
	      className: 'stamp-ListGallery-item',
	      caption: caption,
	      image: image,
	      imageSizes: IMAGE_SIZES,
	      imageStyle: imageStyle,
	      onClick: this.handleImageClick,
	      onTransitionEnd: this.props.onImageTransitionEnd,
	      isImageInLightbox: this.props.isImageInLightbox,
	      lightboxState: this.props.lightboxState });
	  },

	  handleImageClick: function handleImageClick(image, e) {
	    var boundingRect = e.target.getBoundingClientRect();
	    this.props.toggleLightbox(this.props.sectionIndex, SectionTypes.GALLERY, image, boundingRect);
	  }
	});

	module.exports = ListGallery;

/***/ },

/***/ 283:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    StampImageMixin = __webpack_require__(130),
	    Img = __webpack_require__(127),
	    ImageCaption = __webpack_require__(175),
	    PureRenderMixin = __webpack_require__(2),
	    SectionTypes = __webpack_require__(40),
	    gradient = __webpack_require__(123);

	__webpack_require__(38);
	__webpack_require__(345);

	var Poster = React.createClass({
	  displayName: 'Poster',

	  mixins: [StampImageMixin, PureRenderMixin],

	  propTypes: {
	    stamp: React.PropTypes.object.isRequired,
	    background: React.PropTypes.object.isRequired,
	    sectionIndex: React.PropTypes.number.isRequired,
	    isActive: React.PropTypes.bool.isRequired,
	    lightboxState: React.PropTypes.oneOf(['active', 'leaving']),
	    toggleLightbox: React.PropTypes.func.isRequired,
	    getLightboxImageStyle: React.PropTypes.func.isRequired,
	    onImageTransitionEnd: React.PropTypes.func.isRequired
	  },

	  getImageSizes: function getImageSizes() {
	    return {
	      'default': 480,
	      'xs': 640,
	      'sm': 992,
	      'md': 1200,
	      'lg': 1440,
	      'xl': 1600
	    };
	  },

	  getImage: function getImage(props) {
	    return props.background;
	  },

	  render: function render() {
	    var background = this.props.background;
	    var caption = background.caption;
	    var colors = background.colors;var _props = this.props;
	    var isActive = _props.isActive;

	    var lightboxState = _props.lightboxState;
	    var imageStyle = this.props.getLightboxImageStyle(background);
	    var style = {};

	    if (lightboxState || !this.hasLoadedImage()) {
	      style.backgroundImage = gradient('#' + colors.top, '#' + colors.bottom);
	    }

	    return React.createElement(
	      'div',
	      { className: 'stamp-Poster',
	        'data-active': isActive,
	        'data-lightbox': lightboxState,
	        'data-scroll-anchor': true,
	        style: style,
	        onClick: this.toggleAttributionOnMobile },
	      React.createElement(
	        'div',
	        { className: 'stamp-Poster-imageWrapper' },
	        React.createElement(Img, { className: 'stamp-Poster-img',
	          src: this.getImageSrcUrl(),
	          style: imageStyle,
	          onClick: this.handleImageClick,
	          onTransitionEnd: this.props.onImageTransitionEnd,
	          onLoad: this.handleImageLoad,
	          onError: this.handleImageError }),
	        this.renderUsageCounter(),
	        this.renderAttributionOnMobile()
	      ),
	      caption.length > 0 && React.createElement(ImageCaption, { caption: caption,
	        context: 'Poster' })
	    );
	  },

	  handleImageClick: function handleImageClick(e) {
	    var boundingRect = e.target.getBoundingClientRect(),
	        image = this.props.background;

	    this.props.toggleLightbox(this.props.sectionIndex, SectionTypes.POSTER, image, boundingRect);
	  }
	});

	module.exports = Poster;

/***/ },

/***/ 284:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var _ = __webpack_require__(4);
	var LightboxOverlay = __webpack_require__(281);
	var Fade = __webpack_require__(278);
	var FadingCalculatorMixin = __webpack_require__(257);
	var PureRenderMixin = __webpack_require__(2);
	var LightboxMixin = __webpack_require__(258);
	var StampScrollMixin = __webpack_require__(261);
	var BackColorMixin = __webpack_require__(56);
	var UserStore = __webpack_require__(5);
	var ZineStore = __webpack_require__(22);
	var createStoreMixin = __webpack_require__(8);
	var assign = __webpack_require__(15);
	var shallowEqual = __webpack_require__(46);
	var SectionTypes = __webpack_require__(40);
	var MediaTypes = __webpack_require__(70);
	var MediaSources = __webpack_require__(254);
	var GalleryLayouts = __webpack_require__(202);var PropTypes = React.PropTypes;

	var LightboxSections = [SectionTypes.GALLERY, SectionTypes.POSTER, SectionTypes.COVER];

	var SectionComponents = {};
	SectionComponents[SectionTypes.COVER] = __webpack_require__(277);
	SectionComponents[SectionTypes.POSTER] = __webpack_require__(283);
	SectionComponents['' + SectionTypes.GALLERY + ':' + GalleryLayouts.LIST] = __webpack_require__(282);
	SectionComponents['' + SectionTypes.GALLERY + ':' + GalleryLayouts.GRID] = __webpack_require__(279);
	SectionComponents[SectionTypes.TEXT] = __webpack_require__(285);
	SectionComponents[SectionTypes.INFO] = __webpack_require__(280);
	SectionComponents['' + SectionTypes.MEDIA + ':' + MediaTypes.AUDIO_TRACK + ':' + MediaSources.SOUNDCLOUD] = __webpack_require__(275);
	SectionComponents['' + SectionTypes.MEDIA + ':' + MediaTypes.AUDIO_PLAYLIST + ':' + MediaSources.SOUNDCLOUD] = __webpack_require__(274);
	SectionComponents['' + SectionTypes.MEDIA + ':' + MediaTypes.VIDEO + ':' + MediaSources.VIMEO] = __webpack_require__(286);
	SectionComponents[SectionTypes.BUY_IN_ITUNES] = __webpack_require__(276);

	var Stamp = React.createClass({
	  displayName: 'Stamp',

	  mixins: [createStoreMixin(UserStore, ZineStore), PureRenderMixin, FadingCalculatorMixin, LightboxMixin, BackColorMixin, StampScrollMixin],

	  propTypes: {
	    stamp: PropTypes.object.isRequired,
	    nextUp: PropTypes.element,
	    primaryZine: PropTypes.object,
	    isInViewer: PropTypes.bool,
	    onInfoPanelOffsetTopChange: PropTypes.func,
	    showFeedback: PropTypes.bool,
	    disableInfoPanel: PropTypes.bool
	  },

	  getStateFromStores: function getStateFromStores(props) {
	    var stamp = props.stamp;
	    var primaryZine = props.primaryZine;
	    var isInViewer = props.isInViewer;
	    var disableInfoPanel = props.disableInfoPanel;
	    var user = UserStore.get(stamp.user);
	    var zines = (isInViewer ? stamp.zines : []).map(ZineStore.get);
	    var contentSections = stamp.content && stamp.content.sections.slice(1);
	    var handleInfoPanelOffsetTopChange = this.props.onInfoPanelOffsetTopChange;
	    var isLoading = !contentSections;
	    var sections;

	    sections = [{
	      key: stamp.id + '-cover',
	      type: SectionTypes.COVER,
	      stamp: stamp,
	      isLoading: isLoading,
	      primaryZine: primaryZine
	    }];

	    if (!isLoading) {
	      sections = sections.concat(contentSections.map(function (section, i) {
	        return assign({
	          key: stamp.id + '-' + i
	        }, section);
	      }));

	      sections.push({
	        key: stamp.id + '-info',
	        type: SectionTypes.INFO,
	        stamp: stamp,
	        user: user,
	        primaryZine: primaryZine,
	        otherZines: _.without(zines, primaryZine),
	        onOffsetTopChange: handleInfoPanelOffsetTopChange,
	        showFeedback: this.props.showFeedback,
	        disableInfoPanel: disableInfoPanel
	      });
	    }

	    return {
	      sections: sections
	    };
	  },

	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (!shallowEqual(nextProps, this.props)) {
	      this.setState(this.getStateFromStores(nextProps));
	    }

	    if (nextProps.stamp.id !== this.props.stamp.id) {
	      this.resetLightbox();
	    }
	  },

	  render: function render() {
	    var sections = this.state.sections,
	        content = sections.map(this.renderSection);

	    content.push(this.renderLightboxOverlay(sections));

	    return React.createElement(
	      'div',
	      { className: 'stamp-Stamp' },
	      _.compact(_.flatten(content)),
	      sections.length > 1 && this.props.nextUp
	    );
	  },

	  renderSection: function renderSection(section, index, sections) {
	    var fading = this.getSectionFading(index),
	        props = this.getSectionProps(section, index, fading),
	        ComponentType,
	        component;

	    ComponentType = SectionComponents[section.type] || SectionComponents[section.type + ':' + section.layout] || SectionComponents[section.type + ':' + section.mediaType + ':' + section.mediaSource];

	    component = React.createElement(ComponentType, props);

	    return fading ? this.wrapInFades(component, index, sections, fading) : component;
	  },

	  getSectionNode: function getSectionNode(index) {
	    return this.refs['section-' + index].getDOMNode();
	  },

	  getSectionProps: function getSectionProps(section, index, fading) {
	    var type = section.type,
	        props;

	    props = assign({
	      sectionIndex: index,
	      isInViewer: !!this.props.isInViewer,
	      ref: 'section-' + index,
	      stamp: this.props.stamp
	    }, section);

	    delete props.type;

	    if (LightboxSections.indexOf(type) > -1) {
	      assign(props, this.getLightboxProps(index));
	    }

	    if (type === SectionTypes.POSTER) {
	      assign(props, {
	        isActive: fading && fading.isActive || false
	      });
	    }

	    return props;
	  },

	  getLightboxProps: function getLightboxProps(index) {
	    return {
	      lightboxState: this.getLightboxState(index),
	      getLightboxImageStyle: this.getLightboxImageStyle,
	      toggleLightbox: this.toggleLightbox,
	      isImageInLightbox: this.isImageInLightbox,
	      onImageTransitionEnd: this.handleLightboxTransitionEnd,
	      isLightboxEnabled: this.isLightboxEnabled
	    };
	  },

	  wrapInFades: function wrapInFades(component, index, sections, fading) {
	    var isLightboxVisible = this.isLightboxVisible(index),
	        isInViewer = this.props.isInViewer,
	        isLastContentSection = index === sections.length - 2,
	        image = sections[index].background || this.props.stamp.thumbnail || {},
	        colors = image.colors || { top: 'FFFFFF', bottom: 'FFFFFF' },
	        topFade,
	        bottomFade;

	    if (index > 0) {
	      topFade = React.createElement(Fade, { key: index + '-top',
	        color: colors.top,
	        isLightboxVisible: isLightboxVisible,
	        isActive: fading.isActive,
	        isVisible: fading.isVisible,
	        opacity: fading.topOpacity,
	        isTop: true });
	    }

	    // Prevent last fade expanding the container beyond the last section in editor.
	    if (isInViewer || isLightboxVisible || !isLastContentSection) {
	      bottomFade = React.createElement(Fade, { key: index + '-bottom',
	        color: colors.bottom,
	        isLightboxVisible: isLightboxVisible,
	        isActive: fading.isActive,
	        isVisible: fading.isVisible,
	        opacity: fading.bottomOpacity });
	    }

	    return [topFade, component, bottomFade];
	  },

	  renderLightboxOverlay: function renderLightboxOverlay(sections) {
	    if (!this.isFadingEnabled() || !this.getLightboxState()) {
	      return;
	    }

	    var lightbox = this.state.lightbox.current || this.state.lightbox.previous,
	        sectionIndex = lightbox.sectionIndex,
	        sectionType = sections[sectionIndex].type,
	        image = lightbox.image,
	        colors = image.colors,
	        textColor = 'dark',
	        overlayColorStop;

	    if (sectionType === SectionTypes.POSTER) {
	      overlayColorStop = this.getGradientColorStop(colors, this.getSectionFading(sectionIndex).progress);
	      textColor = this.getTextColor(overlayColorStop);
	    } else if (sectionType === SectionTypes.COVER) {
	      overlayColorStop = this.getGradientColorStop(colors, 0.5);
	      textColor = this.getTextColor(overlayColorStop);
	    }

	    return React.createElement(LightboxOverlay, { key: 'overlay',
	      stamp: this.props.stamp,
	      image: image,
	      color: textColor,
	      isInLightbox: this.isInLightbox(sectionIndex),
	      isInViewer: this.props.isInViewer,
	      hideLightbox: this.hideLightbox,
	      sectionType: sectionType });
	  },

	  getGradientColorStop: function getGradientColorStop(colors, progress) {
	    var topRGB = this.parseColor(colors.top),
	        bottomRGB = this.parseColor(colors.bottom);

	    return _.zip(topRGB, bottomRGB).map(function (zipped) {
	      var top = zipped[0],
	          bottom = zipped[1],
	          current = Math.round(top + (bottom - top) * progress);

	      return current.toString(16);
	    }).join('');
	  }
	});

	module.exports = Stamp;

/***/ },

/***/ 285:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1),
	    FontTest = __webpack_require__(92),
	    enforcePElements = __webpack_require__(297);

	__webpack_require__(38);
	__webpack_require__(346);

	var Text = React.createClass({
	  displayName: 'Text',

	  propTypes: {
	    text: React.PropTypes.string.isRequired },

	  shouldComponentUpdate: function shouldComponentUpdate() {
	    return false;
	  },

	  render: function render() {
	    var html = enforcePElements(this.props.text);

	    return React.createElement(
	      'div',
	      { className: 'stamp-Text',
	        'data-scroll-anchor': 'text' },
	      React.createElement(
	        FontTest,
	        { family: 'minion-pro-condensed',
	          test: html },
	        React.createElement('div', { className: 'stamp-Text-box',
	          dangerouslySetInnerHTML: { __html: html } })
	      )
	    );
	  }
	});

	module.exports = Text;

/***/ },

/***/ 286:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var createStoreMixin = __webpack_require__(8);
	var ClassNameMixin = __webpack_require__(3);
	var PlayerActionCreators = __webpack_require__(84);
	var PlayerStore = __webpack_require__(119);
	var PureRenderMixin = __webpack_require__(2);
	var BlurredBackground = __webpack_require__(164);
	var Icon = __webpack_require__(10);
	var Button = __webpack_require__(13);
	var Loader = __webpack_require__(43);
	var formatTime = __webpack_require__(136);
	var ResponsiveImageQueueMixin = __webpack_require__(86);
	var ViewportTestMixin = __webpack_require__(168);
	var MediaTypes = __webpack_require__(70);
	var _require = __webpack_require__(36);

	var isMobile = _require.isMobile;var PropTypes = React.PropTypes;

	__webpack_require__(38);
	__webpack_require__(347);

	var IMAGE_SIZES = {
	  'default': 480,
	  'xs': 640,
	  'sm': 992,
	  'md': 1024,
	  'lg': 1024,
	  'xl': 1280
	};

	var Video = React.createClass({
	  displayName: 'Video',

	  mixins: [createStoreMixin(PlayerStore), ResponsiveImageQueueMixin, ViewportTestMixin, ClassNameMixin, PureRenderMixin],

	  propTypes: {
	    stamp: PropTypes.object.isRequired,
	    uuid: PropTypes.string.isRequired,
	    sourceId: PropTypes.number.isRequired,
	    width: PropTypes.number.isRequired,
	    height: PropTypes.number.isRequired,
	    background: PropTypes.shape({
	      url: PropTypes.string.isRequired,
	      size: PropTypes.object.isRequired,
	      colors: PropTypes.object.isRequired
	    }).isRequired
	  },

	  className: 'stamp-Video',

	  getMediaId: function getMediaId() {
	    return this.props.uuid;
	  },

	  getEmbedMaxHeight: function getEmbedMaxHeight() {
	    var height = this.props.height < 960 / this.props.width * this.props.height ? this.props.height : 960 / this.props.width * this.props.height;

	    return height < 540 ? 540 : height;
	  },

	  getInitialState: function getInitialState() {
	    return {
	      hasPressedPlay: false,
	      isLoaded: false
	    };
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      isPlaying: PlayerStore.isPlaying(this.getMediaId())
	    };
	  },

	  getCSSModifiers: function getCSSModifiers() {
	    var _state = this.state;
	    var hasPressedPlay = _state.hasPressedPlay;
	    var isLoaded = _state.isLoaded;
	    var isReady = hasPressedPlay && (isLoaded || isMobile());

	    return [hasPressedPlay && 'pressedPlay', isReady && 'ready'];
	  },

	  getContentWindow: function getContentWindow() {
	    return this.refs.iframe.getDOMNode().contentWindow;
	  },

	  getImageSizes: function getImageSizes() {
	    return IMAGE_SIZES;
	  },

	  getImageOptions: function getImageOptions() {
	    var devicePixelRatio = typeof window !== 'undefined' ? window.devicePixelRatio : 1;

	    return {
	      image: this.props.background,
	      sizes: {
	        thumb: true,
	        small: this.state.imageSize > 500,
	        normal: true,
	        retina: devicePixelRatio > 1.5 && this.state.isInViewport
	      }
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    window.addEventListener('message', this.handleIframeMessage);
	  },

	  componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
	    if (this.state.isPlaying && !nextState.isPlaying) {
	      this.postMessage('pause');
	    } else if (!this.state.isPlaying && nextState.isPlaying) {
	      this.postMessage('play');
	    }
	  },

	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevState.isInViewport !== this.state.isInViewport) {
	      this.updateImageQueue();
	    }
	  },

	  componentWillUnmount: function componentWillUnmount() {
	    this.pause();
	    window.removeEventListener('message', this.handleIframeMessage);
	    this.clearIdleTimeout();
	  },

	  render: function render() {
	    var src = 'https://player.vimeo.com/video/' + this.props.sourceId,
	        height = this.getEmbedMaxHeight();

	    return React.createElement(
	      'div',
	      { className: this.getClassName(),
	        onClick: this.handlePlayClick,
	        'data-scroll-anchor': true },
	      React.createElement('div', { className: 'stamp-Video-bg',
	        style: {
	          backgroundImage: this.getBackgroundImageUrl()
	        } }),
	      React.createElement(
	        'div',
	        { className: 'stamp-Video-blurredBg' },
	        React.createElement(BlurredBackground, { background: this.props.background })
	      ),
	      this.renderLoaderImg(),
	      React.createElement(
	        'div',
	        { className: 'stamp-Video-box' },
	        React.createElement(
	          'div',
	          { className: 'stamp-Video-embed',
	            style: {
	              paddingBottom: height * 100 / 960 + '%'
	            } },
	          React.createElement('iframe', { src: src,
	            frameBorder: '0',
	            webkitAllowFullScreen: true,
	            mozAllowFullscreen: true,
	            allowFullScreen: true,
	            ref: 'iframe' }),
	          !this.state.isLoaded && React.createElement(
	            'div',
	            { className: 'stamp-Video-play' },
	            this.state.hasPressedPlay ? !isMobile() && React.createElement(Loader, { absoluteCenter: true }) : React.createElement(
	              Button,
	              { absoluteCenter: true,
	                context: 'Video',
	                onClick: this.handlePlayClick,
	                size: 'xxxlarge',
	                color: 'black',
	                overlay: true,
	                round: true },
	              React.createElement(Icon, { name: 'play',
	                mode: 'stroke',
	                size: 'large' }),
	              React.createElement(
	                'div',
	                { className: 'stamp-Video-duration utils--hideOnMobile' },
	                formatTime(this.props.duration)
	              )
	            )
	          )
	        )
	      ),
	      React.createElement(
	        'div',
	        { className: 'stamp-Video-meta' },
	        React.createElement(
	          'div',
	          { className: 'stamp-Video-title' },
	          this.props.title
	        ),
	        React.createElement(
	          'div',
	          { className: 'stamp-Video-author' },
	          this.props.username
	        )
	      )
	    );
	  },

	  handlePlayClick: function handlePlayClick(e) {
	    e.stopPropagation();

	    this.setState({
	      hasPressedPlay: true
	    });

	    if (!this.state.isLoaded) {
	      this.play();
	      this.setIdleTimeout();
	      return;
	    }

	    if (this.state.isPlaying) {
	      this.pause();
	    } else {
	      this.play();
	    }
	  },

	  setIdleTimeout: function setIdleTimeout() {
	    if (!this.idleTimeout) {
	      this.idleTimeout = setTimeout(this.handleVideoIdle, 5000);
	    }
	  },

	  clearIdleTimeout: function clearIdleTimeout() {
	    if (this.idleTimeout) {
	      clearTimeout(this.idleTimeout);
	    }
	  },

	  handleVideoIdle: function handleVideoIdle() {
	    // Go ahead and show iframe if user waited too long
	    this.setState({
	      isLoaded: true
	    });
	  },

	  handleIframeMessage: function handleIframeMessage(e) {
	    if (!this.isMounted()) {
	      return;
	    }

	    if (e.source !== this.getContentWindow()) {
	      return;
	    }

	    var data = null;
	    try {
	      data = JSON.parse(e.data);
	    } catch (err) {
	      // For some reason, this happens from time to time
	      return;
	    }

	    switch (data.event) {
	      case 'ready':
	        this.postMessage('addEventListener', 'play');
	        this.postMessage('addEventListener', 'playProgress');
	        this.postMessage('addEventListener', 'pause');
	        this.postMessage('addEventListener', 'finish');
	        break;

	      case 'play':
	        this.play();
	        break;

	      case 'playProgress':
	        this.handleVideoProgress(data.data);
	        break;

	      case 'pause':
	      case 'finish':
	        this.pause();
	        break;
	    }
	  },

	  handleVideoProgress: function handleVideoProgress(data) {
	    var _this = this;

	    if (!this.state.isLoaded) {
	      this.setState({ isLoaded: true });
	    }

	    // We want to rewind instead of showing related videos.
	    // It's too late to do this in `finish` handler or when `data.progress` is 1.
	    if (data.duration - data.seconds > 0.3) {
	      return;
	    }

	    this.rewind();

	    // Prevents play button stuck in "playing" state in Firefox:
	    requestAnimationFrame(function () {
	      _this.postMessage('pause');
	    });
	  },

	  rewind: function rewind() {
	    // This works better than sending `unload` because it doesn't flicker.
	    this.postMessage('seekTo', 0);
	    this.postMessage('pause');
	  },

	  play: function play() {
	    PlayerActionCreators.play(this.getMediaId(), {
	      mediaType: MediaTypes.VIDEO,
	      stampId: this.props.stamp.id
	    });
	  },

	  pause: function pause() {
	    PlayerActionCreators.pause(this.getMediaId());
	  },

	  postMessage: function postMessage(action, value) {
	    var data = {
	      method: action,
	      value: value
	    };

	    var message = JSON.stringify(data),
	        contentWindow = this.getContentWindow(),
	        url = 'https://player.vimeo.com/video/' + this.props.sourceId;

	    contentWindow.postMessage(message, url);
	  }
	});

	module.exports = Video;

/***/ },

/***/ 297:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	// This code is almost identical to Scribe source code,
	// except that we added a few more known block tags.

	// See https://github.com/guardian/scribe/blob/master/src/plugins/core/formatters/html/enforce-p-elements.js

	var _ = __webpack_require__(4);

	var blockElementNames = ['P', 'DIV', 'BLOCKQUOTE', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'UL', 'OL', 'LI'];

	function isBlockElement(node) {
	  return _.contains(blockElementNames, node.nodeName);
	}

	/**
	 * Wrap consecutive inline elements and text nodes in a P element.
	 */
	function wrapChildNodes(parentNode) {
	  var groups = Array.prototype.reduce.call(parentNode.childNodes, function (accumulator, binChildNode) {
	    function startNewGroup() {
	      var newGroup = [binChildNode];
	      accumulator.push(newGroup);
	    }

	    var group = _.last(accumulator);
	    if (!group) {
	      startNewGroup();
	    } else {
	      var isBlockGroup = isBlockElement(group[0]);
	      if (isBlockGroup === isBlockElement(binChildNode)) {
	        group.push(binChildNode);
	      } else {
	        startNewGroup();
	      }
	    }

	    return accumulator;
	  }, []);

	  var consecutiveInlineElementsAndTextNodes = groups.filter(function (group) {
	    var isBlockGroup = isBlockElement(group[0]);
	    return !isBlockGroup;
	  });

	  consecutiveInlineElementsAndTextNodes.forEach(function (nodes) {
	    var pElement = document.createElement('p');
	    nodes[0].parentNode.insertBefore(pElement, nodes[0]);
	    nodes.forEach(function (node) {
	      pElement.appendChild(node);
	    });
	  });

	  parentNode._isWrapped = true;
	}

	function enforcePElements(html) {
	  var bin = document.createElement('div');
	  bin.innerHTML = html;

	  // Only wrap immediate children--unlike Scribe,
	  // we don't care about <blockquote> contents.

	  wrapChildNodes(bin);

	  return bin.innerHTML;
	}

	module.exports = enforcePElements;

/***/ },

/***/ 300:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _require = __webpack_require__(4);

	var memoize = _require.memoize;

	var supportsPositionSticky = memoize(function () {
	    // https://github.com/phistuck/Modernizr/commit/3fb7217f5f8274e2f11fe6cfeda7cfaf9948a1f5
	    var prop = 'position:',
	        value = 'sticky',
	        el = document.createElement('test'),
	        style = el.style;

	    style.cssText = prop + ['-webkit-', '-moz-', '-ms-', '-o-', ''].join(value + ';' + prop) + value + ';';
	    return style.position.indexOf(value) !== -1;
	});

	module.exports = supportsPositionSticky;

/***/ },

/***/ 301:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var prefix = (function () {
	  var styles = window.getComputedStyle(document.documentElement, ''),
	      pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1],
	      dom = 'WebKit|Moz|MS|O'.match(new RegExp('(' + pre + ')', 'i'))[1];
	  return {
	    dom: dom,
	    lowercase: pre,
	    css: '-' + pre + '-',
	    js: pre === 'ms' ? 'ms' : pre[0].toUpperCase() + pre.substr(1)
	  };
	})();

	module.exports = prefix;

/***/ },

/***/ 315:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".BlurredBackground{width:100%;height:100%;background-repeat:no-repeat;background-position:center;background-size:cover}", ""]);

/***/ },

/***/ 316:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".ImageUsageCounter{z-index:202;position:absolute;bottom:1rem;left:1rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 .5rem;border-radius:2px;height:1.5rem;background-color:rgba(0,0,0,.5);color:#fff;opacity:.65;-webkit-transition:opacity .3s cubic-bezier(.175,.885,.32,1);transition:opacity .3s cubic-bezier(.175,.885,.32,1);-webkit-transition-delay:.5s;transition-delay:.5s;pointer-events:none}.ImageUsageCounter-count{margin-left:.5rem;font-weight:700;font-size:.875rem}[data-lightbox=active] .ImageUsageCounter{opacity:0;-webkit-transition-delay:0s;transition-delay:0s}", ""]);

/***/ },

/***/ 317:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".TrackList{margin-top:1.5em;padding-top:1.5em;border-top:1px solid rgba(255,255,255,.15)}.TrackList-track{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;color:#fff;cursor:pointer}.TrackList-track:after{position:absolute;content:\"\";top:-.25rem;right:-1rem;bottom:-.25rem;left:-1rem;background-color:#fff;opacity:0;border-radius:1000px;-webkit-transition:opacity .3s cubic-bezier(.175,.885,.32,1);transition:opacity .3s cubic-bezier(.175,.885,.32,1)}.TrackList-track:hover:after{opacity:.1}.TrackList-track~.TrackList-track{margin-top:1rem}.TrackList-track.TrackList-track--active{color:#000}.TrackList-track.TrackList-track--active .TrackList-trackTitle{position:relative;opacity:1}.TrackList-track.TrackList-track--active .TrackList-trackDuration{opacity:1}.TrackList-track.TrackList-track--active:after{opacity:.95}.TrackList-trackTitle{z-index:1;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;overflow:hidden;font-size:1rem;white-space:nowrap;text-overflow:ellipsis;opacity:.8}@media only screen and (min-width:40em){.TrackList-trackTitle{font-size:1.125rem}}@media only screen and (min-width:75em){.TrackList-trackTitle{font-size:1.25rem}}.TrackList-trackDuration{z-index:1;-ms-flex-negative:0;flex-shrink:0;margin-left:1rem;font-size:1rem;opacity:.5}@media only screen and (min-width:40em){.TrackList-trackDuration{font-size:1.125rem}}@media only screen and (min-width:75em){.TrackList-trackDuration{font-size:1.25rem}}", ""]);

/***/ },

/***/ 318:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-AudioContainer{position:relative}.stamp-AudioContainer-bg{position:absolute;top:0;left:0;width:100%;height:100%}.stamp-AudioContainer-bg:before{position:absolute;content:'';top:0;right:0;bottom:0;left:0;background-color:rgba(0,0,0,.3);box-shadow:inset 0 1px 0 rgba(0,0,0,.1),inset 0 -1px 0 rgba(0,0,0,.1)}@media only screen and (min-width:40em){.stamp-AudioContainer-box{display:-webkit-box;display:-ms-flexbox;display:flex}}.stamp-AudioContainer-player{-ms-flex-negative:0;flex-shrink:0}.stamp-AudioContainer-meta{position:relative;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:1.5rem 1rem}@media only screen and (min-width:40em){.stamp-AudioContainer-meta{padding:0 0 0 2.5em;background-color:transparent;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}", ""]);

/***/ },

/***/ 319:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-BuyInItunes{background-color:#763188!important}.stamp-BuyInItunes-box{position:relative;padding:1.75rem;border-radius:2px;background-color:#fff;box-shadow:0 4px 24px rgba(0,0,0,.15),0 0 0 1px rgba(0,0,0,.05)}@media only screen and (min-width:40em){.stamp-BuyInItunes-box{display:-webkit-box;display:-ms-flexbox;display:flex;max-width:46rem!important}}.stamp-BuyInItunes-label{display:none;position:absolute;top:-2rem;left:0;color:#fff;font-weight:700;font-size:.875rem;opacity:.75}@media only screen and (min-width:62em){.stamp-BuyInItunes-label{display:block}}.stamp-BuyInItunes-cover{-ms-flex-negative:0;flex-shrink:0;position:relative;width:100%;padding-bottom:100%;height:0;border-radius:2px;background-size:cover;background-repeat:no-repeat;background-position:center;background-color:#797b80}@media only screen and (min-width:40em){.stamp-BuyInItunes-cover{width:12rem;height:12rem;padding-bottom:0}}.stamp-BuyInItunes-coverLink{position:absolute;top:0;right:0;bottom:0;left:0}.stamp-BuyInItunes-meta{position:relative;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-top:1.5rem;color:#2e2f33}@media only screen and (min-width:40em){.stamp-BuyInItunes-meta{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;margin-top:0;margin-left:1.5rem;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}}.stamp-BuyInItunes-title,.stamp-BuyInItunes-artist{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:100%}.stamp-BuyInItunes-button{margin-top:2rem}.stamp-BuyInItunes-title{margin-bottom:.25rem;font-weight:700;font-size:1.5rem}@media only screen and (min-width:40em){.stamp-BuyInItunes-title{font-size:1.75rem}}.stamp-BuyInItunes-author{opacity:.75;font-size:1.125rem}", ""]);

/***/ },

/***/ 320:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-Cover{overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:24rem;color:#fff;background-color:#2e2f33;background-position:center;background-size:cover}@media only screen and (min-width:40em){.stamp-Cover{min-height:100vh}}.stamp-Cover:before{z-index:201;position:absolute;top:0;right:0;bottom:0;left:0;content:'';background-color:rgba(0,0,0,.35);pointer-events:none;-webkit-transition:opacity .3s cubic-bezier(.175,.885,.32,1);transition:opacity .3s cubic-bezier(.175,.885,.32,1)}.stamp-Cover[data-lightbox=active]:before{opacity:0}.stamp-Cover--clickable{cursor:auto}@media only screen and (min-width:62em){.stamp-Cover--clickable{cursor:zoom-in}}@media only screen and (min-width:62em){[data-lightbox=active] .stamp-Cover{cursor:zoom-out}}.App--ie .stamp-Cover{height:100vh}.stamp-Cover-imgWrapper{position:absolute;left:0;top:0;width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;z-index:0}.stamp-Cover-img{width:100%;-webkit-transition:-webkit-transform .5s cubic-bezier(.175,.885,.32,1) 0s;transition:transform .5s cubic-bezier(.175,.885,.32,1) 0s}.stamp-Cover-box{z-index:202;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;word-wrap:break-word;-webkit-transition:opacity .1s linear;transition:opacity .1s linear}@media only screen and (min-width:40em){.stamp-Cover-box{margin:4.5rem auto 3rem}}.stamp-Cover-bestOf2014{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:.75rem;padding:0 .75rem;height:1.5rem;border-radius:1000px;background-color:#60f991;color:#000;font-size:.75rem;font-weight:700;text-transform:uppercase;letter-spacing:.0625em;opacity:.9;-webkit-transition:opacity .3s cubic-bezier(.175,.885,.32,1);transition:opacity .3s cubic-bezier(.175,.885,.32,1)}.stamp-Cover-bestOf2014:hover{opacity:1}@media only screen and (min-width:40em){.stamp-Cover-bestOf2014{margin-bottom:1.75rem;padding:0 1.75rem;height:2rem;font-size:.875rem}}.stamp-Cover-title{font-size:2.25rem;line-height:1}@media only screen and (min-width:40em){.stamp-Cover-title{font-size:3.75rem}}@media only screen and (min-width:75em){.stamp-Cover-title{font-size:4.6875rem}}.stamp-Cover-subtitle{margin-top:.5em;max-width:46rem;font-family:minion-pro-condensed,serif;font-size:1.25rem;font-weight:400;line-height:1.2;opacity:.75}@media only screen and (min-width:40em){.stamp-Cover-subtitle{font-size:1.75rem}}.stamp-Cover[data-lightbox=active] .stamp-Cover-box,.stamp-Cover[data-lightbox=active] .stamp-Cover-bestOf2014{opacity:0}", ""]);

/***/ },

/***/ 321:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-Fade{position:absolute;left:0;z-index:203;display:none;width:100%;height:100vh;-webkit-transition:none;transition:none;-webkit-transform:translate(0,0);transform:translate(0,0);will-change:transform,opacity}.stamp-Fade[data-animate=true]{-webkit-transition:opacity .1s linear;transition:opacity .1s linear}@media only screen and (min-width:62em){.stamp-Fade{display:block}}.stamp-Fade--top{-webkit-transform:translate(0,-100%);transform:translate(0,-100%)}", ""]);

/***/ },

/***/ 322:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-GalleryImage{width:100%;max-width:100%}.stamp-GalleryImage-imageWrapper{position:relative}.stamp-GalleryImage-imageWrapper img{width:100%;max-width:100%;vertical-align:bottom;-webkit-transition:-webkit-transform .5s cubic-bezier(.175,.885,.32,1);transition:transform .5s cubic-bezier(.175,.885,.32,1);will-change:transform;cursor:normal}@media only screen and (min-width:62em){.stamp-GalleryImage-imageWrapper img{cursor:zoom-in}}@media only screen and (min-width:62em){[data-lightbox=active] img{cursor:zoom-out}}", ""]);

/***/ },

/***/ 323:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-GridGallery-row{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media only screen and (min-width:40em){.stamp-GridGallery-row{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.stamp-GridGallery-row~.stamp-GridGallery-row{margin-top:1rem}@media only screen and (min-width:40em){.stamp-GridGallery-row~.stamp-GridGallery-row{margin-top:1.5%}}.stamp-GridGallery-item{position:relative;vertical-align:top}@media(max-width:40em){.stamp-GridGallery-item~.stamp-GridGallery-item{margin-top:1rem}}@media only screen and (min-width:40em){.stamp-GridGallery-item{margin:0}.stamp-GridGallery-item:nth-child(even){padding-left:.75%}.stamp-GridGallery-item:nth-child(odd){padding-right:.75%}.stamp-GridGallery-item:only-child{padding:0}}.stamp-GridGallery-item.stamp-GridGallery-item--lightbox{position:relative;z-index:1}", ""]);

/***/ },

/***/ 324:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-ImageCaption{padding:.75em 0;color:#797b80}.stamp-ImageCaption-text{margin:0 auto;text-align:center;font-family:minion-pro-condensed,serif;font-style:italic;font-size:1.125rem;white-space:normal;word-wrap:break-word;pointer-events:auto}.stamp-ImageCaption.stamp-ImageCaption--isInPoster{padding-bottom:1.75rem;background-color:#fff;-webkit-transition:opacity .3s cubic-bezier(.175,.885,.32,1);transition:opacity .3s cubic-bezier(.175,.885,.32,1);-webkit-transition-delay:.5s;transition-delay:.5s}@media only screen and (min-width:62em){.stamp-ImageCaption.stamp-ImageCaption--isInPoster{position:absolute;bottom:0;right:0;left:0;padding:8rem 0 3.5rem;color:#fff;background-color:transparent;background-image:-webkit-linear-gradient(bottom,rgba(0,0,0,.5),transparent);background-image:linear-gradient(to top,rgba(0,0,0,.5),transparent)}}@media(max-width:62em){.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-box{padding-left:.75rem;padding-right:.75rem}}@media only screen and (min-width:62em){.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-box{position:relative;padding-top:1.75rem}.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-box:before,.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-box:after{position:absolute;left:0;right:0;content:\"\";display:block;margin:0 auto;width:4rem;height:1px;background-color:currentColor;opacity:.5}.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-box:before{top:0;opacity:.5}.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-box:after{top:-3px;opacity:.5}}.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-text{line-height:1.3}@media only screen and (min-width:62em){.stamp-ImageCaption.stamp-ImageCaption--isInPoster .stamp-ImageCaption-text{font-size:1.5rem}}[data-lightbox=active] .stamp-ImageCaption.stamp-ImageCaption--isInPoster{opacity:0;-webkit-transition:opacity 0s cubic-bezier(.175,.885,.32,1);transition:opacity 0s cubic-bezier(.175,.885,.32,1);-webkit-transition-delay:0s;transition-delay:0s}", ""]);

/***/ },

/***/ 325:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".InfoPanel{background-color:#fff;color:#2e2f33;padding-bottom:1.25rem}.InfoPanel[data-disabled=true]{pointer-events:none}.InfoPanel-box{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:0 auto;width:100%;max-width:46rem}.InfoPanel-label{width:100%;margin-bottom:.75rem;text-align:center;color:#797b80}.InfoPanel-section{padding:1.75rem 0}@media only screen and (min-width:40em){.InfoPanel-section{padding:3.5rem 0}}.InfoPanel-section.InfoPanel-section--buttons{border-top:1px solid #e8e8e8;border-bottom:1px solid #e8e8e8}.InfoPanel-section.InfoPanel-section--userAndZine{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch}@media only screen and (min-width:40em){.InfoPanel-section.InfoPanel-section--userAndZine{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}.InfoPanel-section.InfoPanel-section--feedback{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.InfoPanel-zine{position:relative;margin-top:.75rem}@media only screen and (min-width:40em){.InfoPanel-zine{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-top:0;margin-left:3.5rem}}.InfoPanel-otherZines,.InfoPanel-date{height:1.75rem;margin-top:.75rem;font-size:.875rem;color:#797b80;text-align:center}.InfoPanel-user{position:relative;margin-bottom:.75rem}@media only screen and (min-width:40em){.InfoPanel-user{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:0}}.InfoPanel-buttons{position:relative;-ms-flex-item-align:stretch;align-self:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.InfoPanel-share{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

/***/ },

/***/ 326:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-LightboxOverlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.95);opacity:0;-webkit-transition:opacity .1s linear;transition:opacity .1s linear;will-change:opacity;pointer-events:none;z-index:204}.stamp-LightboxOverlay[data-active=true]{opacity:1;pointer-events:auto;cursor:zoom-out}.stamp-LightboxOverlay.stamp-LightboxOverlay--poster,.stamp-LightboxOverlay.stamp-LightboxOverlay--cover{background-color:transparent}", ""]);

/***/ },

/***/ 327:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-ListGallery-item{position:relative;margin-bottom:1rem;text-align:center}.stamp-ListGallery-item:last-child{margin-bottom:0}@media only screen and (min-width:40em){.stamp-ListGallery-item{margin-bottom:2rem}}@media only screen and (min-width:62em){.stamp-ListGallery-item{margin-bottom:2rem}}@media only screen and (min-width:75em){.stamp-ListGallery-item{margin-bottom:3rem}}@media only screen and (min-width:100em){.stamp-ListGallery-item{margin-bottom:4rem}}", ""]);

/***/ },

/***/ 328:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-Poster{position:relative;line-height:0}.stamp-Poster[data-active=false]{-moz-user-select:none}@media only screen and (min-width:62em){.stamp-Poster[data-active=false]{pointer-events:none}}.stamp-Poster-imageWrapper{position:relative}.stamp-Poster-img{width:100%;vertical-align:bottom;cursor:auto;-webkit-transition:-webkit-transform .5s cubic-bezier(.175,.885,.32,1);transition:transform .5s cubic-bezier(.175,.885,.32,1);will-change:transform}@media only screen and (min-width:62em){.stamp-Poster-img{cursor:zoom-in}}@media only screen and (min-width:62em){[data-lightbox=active] .stamp-Poster-img{cursor:zoom-out}}", ""]);

/***/ },

/***/ 329:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-Text{font-family:minion-pro-condensed,serif;color:#2e2f33}.stamp-Text-box{word-wrap:break-word}.stamp-Text-box>*:first-child{margin-top:0}.stamp-Text-box>*:last-child{margin-bottom:0}.stamp-Text-box p{margin:1.5em auto;max-width:46rem;font-size:1.125rem}@media only screen and (min-width:40em){.stamp-Text-box p{font-size:1.5rem}}.stamp-Text-box h3{margin:0 auto 1.5em;max-width:46rem;font-size:1.5rem;text-align:center}@media only screen and (min-width:40em){.stamp-Text-box h3{font-size:2.25rem}}.stamp-Text-box blockquote,.stamp-Text-box blockquote p,.stamp-Text-box blockquote span{max-width:none;color:#797b80;font-size:1.25rem;font-style:italic;text-align:center}@media only screen and (min-width:40em){.stamp-Text-box blockquote,.stamp-Text-box blockquote p,.stamp-Text-box blockquote span{font-size:1.75rem}}@media only screen and (min-width:62em){.stamp-Text-box blockquote,.stamp-Text-box blockquote p,.stamp-Text-box blockquote span{font-size:2.25rem}}.stamp-Text-box blockquote p,.stamp-Text-box blockquote p p,.stamp-Text-box blockquote span p,.stamp-Text-box blockquote span,.stamp-Text-box blockquote p span,.stamp-Text-box blockquote span span{margin:0}.stamp-Text-box blockquote{margin:2em auto}.stamp-Text-box blockquote:before{display:block;margin:0 auto .5em}.stamp-Text-box blockquote:after{display:block;margin:.5em auto 0}.stamp-Text-box blockquote+blockquote:before{display:none}", ""]);

/***/ },

/***/ 330:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-Video{position:relative;background-color:#000;cursor:pointer}.stamp-Video-box{color:#fff;overflow:hidden}.stamp-Video-bg,.stamp-Video-blurredBg{position:absolute;top:0;left:0;width:100%;height:100%}.stamp-Video-bg:before,.stamp-Video-blurredBg:before{position:absolute;content:'';top:0;right:0;bottom:0;left:0;background-image:-webkit-linear-gradient(bottom,rgba(0,0,0,.4),transparent);background-image:linear-gradient(to top,rgba(0,0,0,.4),transparent)}.stamp-Video-bg{background-repeat:no-repeat;background-position:center;background-size:cover}.stamp-Video-blurredBg{-webkit-transition:opacity .2s ease-out;transition:opacity .2s ease-out;will-change:opacity;opacity:0}.stamp-Video-embed{position:relative}.stamp-Video-embed img{max-width:100%;vertical-align:bottom;opacity:0}.stamp-Video-embed iframe{position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;pointer-events:none;-webkit-transform:scale(.75);transform:scale(.75);will-change:transform;-webkit-transition:opacity .5s ease-out,-webkit-transform 1s cubic-bezier(.175,.885,.32,1);transition:opacity .5s ease-out,transform 1s cubic-bezier(.175,.885,.32,1)}.stamp-Video-duration{position:absolute;bottom:1rem;margin:0 .5rem;left:0;right:0;text-align:center;font-size:.875rem}.stamp-Video-meta{position:relative;width:100%;padding:.75rem;z-index:1;text-align:center;-webkit-transition:opacity .25s ease-out;transition:opacity .25s ease-out;color:#fff;background-color:rgba(0,0,0,.5)}@media only screen and (min-width:40em){.stamp-Video-meta{padding:1.75rem}}@media only screen and (min-width:62em){.stamp-Video-meta{position:absolute;bottom:0;background-color:transparent}}.stamp-Video-title,.stamp-Video-author{max-width:46rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin:0 auto}.stamp-Video-title{margin-bottom:.5rem;font-weight:700;font-size:1.25rem}@media only screen and (min-width:40em){.stamp-Video-title{font-size:1.75rem}}@media only screen and (min-width:75em){.stamp-Video-title{font-size:2.25rem}}.stamp-Video-author{opacity:.75}@media only screen and (min-width:40em){.stamp-Video-author{font-size:1.125rem}}.stamp-Video--pressedPlay .stamp-Video-blurredBg{opacity:1}.stamp-Video--ready{cursor:default}.stamp-Video--ready .stamp-Video-embed iframe{-webkit-transform:scale(1);transform:scale(1);opacity:1;pointer-events:auto}@media only screen and (min-width:62em){.stamp-Video--ready .stamp-Video-meta{opacity:0;pointer-events:none}}", ""]);

/***/ },

/***/ 331:
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(18)();
	exports.push([module.id, ".stamp-Cover,.stamp-Text,.stamp-ListGallery,.stamp-GridGallery,.stamp-Poster,.stamp-Video,.stamp-AudioContainer,.stamp-Info,.stamp-BuyInItunes{z-index:200}.stamp-Cover+.stamp-Poster,.stamp-Poster+.stamp-Poster{margin-top:1rem}@media only screen and (min-width:62em){.stamp-Cover+.stamp-Poster,.stamp-Poster+.stamp-Poster{margin-top:0}}.stamp-ListGallery[data-lightbox=active],.stamp-GridGallery[data-lightbox=active],.stamp-Poster[data-lightbox=active],.stamp-ListGallery[data-lightbox=leaving],.stamp-GridGallery[data-lightbox=leaving],.stamp-Poster[data-lightbox=leaving]{z-index:auto}.stamp-Cover,.stamp-Text,.stamp-ListGallery,.stamp-GridGallery,.stamp-AudioContainer,.stamp-Info,.stamp-BuyInItunes{position:relative;padding:1.25rem .75rem;background-color:#fff}@media only screen and (min-width:40em){.stamp-Cover,.stamp-Text,.stamp-ListGallery,.stamp-GridGallery,.stamp-AudioContainer,.stamp-Info,.stamp-BuyInItunes{padding:2.75rem 1.75rem}.stamp-Cover.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-Text.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-ListGallery.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-GridGallery.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-AudioContainer.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-Info.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-BuyInItunes.stamp-AudioContainer--supportsSticky .AudioCover{position:-webkit-sticky;position:sticky;top:2.75rem}}@media only screen and (min-width:62em){.stamp-Cover,.stamp-Text,.stamp-ListGallery,.stamp-GridGallery,.stamp-AudioContainer,.stamp-Info,.stamp-BuyInItunes{padding:5rem 3.5rem}.stamp-Cover.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-Text.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-ListGallery.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-GridGallery.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-AudioContainer.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-Info.stamp-AudioContainer--supportsSticky .AudioCover,.stamp-BuyInItunes.stamp-AudioContainer--supportsSticky .AudioCover{position:-webkit-sticky;position:sticky;top:5rem}}.stamp-Cover-box,.stamp-Text-box,.stamp-ListGallery-box,.stamp-AudioContainer-box,.stamp-Video-box,.stamp-GridGallery-box,.stamp-ImageCaption-box,.stamp-BuyInItunes-box{position:relative;margin:0 auto}.stamp-Cover-box,.stamp-ListGallery-box,.stamp-Video-box,.stamp-AudioContainer-box,.stamp-GridGallery-box,.stamp-Text-box,.stamp-BuyInItunes-box{max-width:100%}@media only screen and (min-width:40em){.stamp-Cover-box,.stamp-ListGallery-box,.stamp-Video-box,.stamp-AudioContainer-box,.stamp-GridGallery-box,.stamp-Text-box,.stamp-BuyInItunes-box{max-width:46rem}}@media only screen and (min-width:75em){.stamp-Cover-box,.stamp-ListGallery-box,.stamp-Video-box,.stamp-AudioContainer-box,.stamp-GridGallery-box,.stamp-Text-box,.stamp-BuyInItunes-box{max-width:56rem}}@media only screen and (min-width:40em){.stamp-ImageCaption-box{max-width:46rem}}.stamp-ListGallery+.stamp-Text,.stamp-GridGallery+.stamp-Text,.stamp-Text+.stamp-ListGallery,.stamp-Text+.stamp-GridGallery{padding-top:0}.stamp-ListGallery+.stamp-ListGallery:before,.stamp-GridGallery+.stamp-GridGallery:before,.stamp-ListGallery+.stamp-GridGallery:before,.stamp-GridGallery+.stamp-ListGallery:before,.stamp-Text+.stamp-Text:before,.stamp-ListGallery+.stamp-ListGallery:after,.stamp-GridGallery+.stamp-GridGallery:after,.stamp-ListGallery+.stamp-GridGallery:after,.stamp-GridGallery+.stamp-ListGallery:after,.stamp-Text+.stamp-Text:after{position:absolute;left:0;right:0;content:\"\";display:block;margin:0 auto;width:4rem;height:1px;background-color:rgba(121,123,128,.5)}.stamp-ListGallery+.stamp-ListGallery:before,.stamp-GridGallery+.stamp-GridGallery:before,.stamp-ListGallery+.stamp-GridGallery:before,.stamp-GridGallery+.stamp-ListGallery:before,.stamp-Text+.stamp-Text:before{top:0}.stamp-ListGallery+.stamp-ListGallery:after,.stamp-GridGallery+.stamp-GridGallery:after,.stamp-ListGallery+.stamp-GridGallery:after,.stamp-GridGallery+.stamp-ListGallery:after,.stamp-Text+.stamp-Text:after{top:-3px}", ""]);

/***/ },

/***/ 332:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(315);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/atoms/BlurredBackground.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/atoms/BlurredBackground.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 333:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(316);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/molecules/ImageUsageCounter.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/molecules/ImageUsageCounter.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 334:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(317);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/molecules/TrackList.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/molecules/TrackList.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 335:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(318);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/AudioContainer.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/AudioContainer.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 336:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(319);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/BuyInItunes.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/BuyInItunes.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 337:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(320);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Cover.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Cover.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 338:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(321);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Fade.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Fade.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 339:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(322);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/GalleryImage.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/GalleryImage.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 340:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(323);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/GridGallery.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/GridGallery.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 341:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(324);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/ImageCaption.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/ImageCaption.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 342:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(325);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/InfoPanel.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/InfoPanel.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 343:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(326);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/LightboxOverlay.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/LightboxOverlay.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 344:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(327);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/ListGallery.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/ListGallery.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 345:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(328);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Poster.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Poster.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 346:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(329);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Text.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Text.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 347:
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(330);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(19)(content, {});
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		module.hot.accept("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Video.less", function() {
			var newContent = require("!!/code/node_modules/css-loader/index.js?-minimize!/code/node_modules/postcss-loader/index.js!/code/node_modules/less-loader/index.js!/code/src/scripts/stamp/Video.less");
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },

/***/ 641:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	  createStampPage: __webpack_require__(754)
	};

/***/ },

/***/ 728:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var React = __webpack_require__(1);
	var Group = __webpack_require__(45);
	var PureRenderMixin = __webpack_require__(2);
	var StampPageMixins = __webpack_require__(260);var PropTypes = React.PropTypes;

	var TrendingNextUp = React.createClass({
	  displayName: 'TrendingNextUp',

	  mixins: [StampPageMixins.Feed, PureRenderMixin],

	  propTypes: {
	    perFirstPage: PropTypes.number.isRequired,
	    itemProps: PropTypes.object,
	    getItemProps: PropTypes.func
	  },

	  getStateFromStores: function getStateFromStores() {
	    return {
	      stamps: this.getPage(),
	      nextUpTitle: this.getNextUpTitle(),
	      isExpectingPage: this.isExpectingPage()
	    };
	  },

	  componentDidMount: function componentDidMount() {
	    this.requestPage(true);
	  },

	  render: function render() {
	    var _state = this.state;
	    var nextUpTitle = _state.nextUpTitle;
	    var stamps = _state.stamps;
	    var isExpectingPage = _state.isExpectingPage;
	    var isLastPage = _state.isLastPage;var _props = this.props;
	    var getItemProps = _props.getItemProps;
	    var itemProps = _props.itemProps;

	    return React.createElement(Group, { type: 'stamps',
	      mode: 'grid',
	      columns: 3,
	      context: 'page',
	      title: nextUpTitle,
	      items: stamps,
	      itemProps: itemProps,
	      getItemProps: getItemProps,
	      isExpectingPage: isExpectingPage,
	      isLastPage: isLastPage,
	      isInvalidated: false,
	      perFirstPage: this.props.perFirstPage });
	  }
	});

	module.exports = TrendingNextUp;

/***/ },

/***/ 754:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	var _slicedToArray = __webpack_require__(61)['default'];

	var _Promise = __webpack_require__(99)['default'];

	var _interopRequireDefault = __webpack_require__(7)['default'];

	var _react = __webpack_require__(1);

	var _react2 = _interopRequireDefault(_react);

	var _underscore = __webpack_require__(4);

	var _underscore2 = _interopRequireDefault(_underscore);

	var _storesStampStore = __webpack_require__(17);

	var _storesStampStore2 = _interopRequireDefault(_storesStampStore);

	var _actionsStampActionCreators = __webpack_require__(54);

	var _actionsStampActionCreators2 = _interopRequireDefault(_actionsStampActionCreators);

	var _constantsPageControlsTypes = __webpack_require__(94);

	var _constantsPageControlsTypes2 = _interopRequireDefault(_constantsPageControlsTypes);

	var _storesLightboxStore = __webpack_require__(147);

	var _storesLightboxStore2 = _interopRequireDefault(_storesLightboxStore);

	var _constantsNavigationContextTypes = __webpack_require__(51);

	var _constantsNavigationContextTypes2 = _interopRequireDefault(_constantsNavigationContextTypes);

	var _stampStamp = __webpack_require__(284);

	var _stampStamp2 = _interopRequireDefault(_stampStamp);

	var _atomsLoader = __webpack_require__(43);

	var _atomsLoader2 = _interopRequireDefault(_atomsLoader);

	var _organismsContainer = __webpack_require__(81);

	var _organismsContainer2 = _interopRequireDefault(_organismsContainer);

	var _atomsOffsetMonitor = __webpack_require__(128);

	var _atomsOffsetMonitor2 = _interopRequireDefault(_atomsOffsetMonitor);

	var _organismsGroup = __webpack_require__(45);

	var _organismsGroup2 = _interopRequireDefault(_organismsGroup);

	var _organismsTrendingNextUp = __webpack_require__(728);

	var _organismsTrendingNextUp2 = _interopRequireDefault(_organismsTrendingNextUp);

	var _mixinsScrollStateMixin = __webpack_require__(115);

	var _mixinsScrollStateMixin2 = _interopRequireDefault(_mixinsScrollStateMixin);

	var _mixinsScreenSizeMixin = __webpack_require__(71);

	var _mixinsScreenSizeMixin2 = _interopRequireDefault(_mixinsScreenSizeMixin);

	var _mixinsPureRenderMixin = __webpack_require__(2);

	var _mixinsPureRenderMixin2 = _interopRequireDefault(_mixinsPureRenderMixin);

	var _reactLibInvariant = __webpack_require__(11);

	var _reactLibInvariant2 = _interopRequireDefault(_reactLibInvariant);

	var _reactLibShallowEqual = __webpack_require__(46);

	var _reactLibShallowEqual2 = _interopRequireDefault(_reactLibShallowEqual);

	var _humps = __webpack_require__(186);

	var _utilsWaitForElasticScroll = __webpack_require__(222);

	var _utilsWaitForElasticScroll2 = _interopRequireDefault(_utilsWaitForElasticScroll);

	var _utilsBrowser = __webpack_require__(36);

	var _atomsDocumentTitle = __webpack_require__(68);

	var _atomsDocumentTitle2 = _interopRequireDefault(_atomsDocumentTitle);

	var _utilsGetStampCountPerRow = __webpack_require__(149);

	var _utilsGetStampCountPerRow2 = _interopRequireDefault(_utilsGetStampCountPerRow);

	var _mixinsStampPageMixins = __webpack_require__(260);

	var _mixinsStampPageMixins2 = _interopRequireDefault(_mixinsStampPageMixins);

	var _utilsDelay = __webpack_require__(789);

	var _utilsDelay2 = _interopRequireDefault(_utilsDelay);

	var _AppContext = __webpack_require__(67);

	var _AppContext2 = _interopRequireDefault(_AppContext);

	var _utilsParseStampSegment = __webpack_require__(53);

	var _utilsParseStampSegment2 = _interopRequireDefault(_utilsParseStampSegment);

	'use strict';

	var MIN_NEXT_STAMP_COUNT = 3,
	    MAX_PREFETCH_COUNT = 3;

	/**
	 * Creates a stamp page handler for route.
	 * Expects StampPageMixin to provide `getPage`, `requestPage`.
	 */
	function createStampPage(_ref) {
	  var routeName = _ref.routeName;
	  var stampPageMixin = _ref.stampPageMixin;

	  (0, _reactLibInvariant2['default'])(stampPageMixin, 'stampPageMixin is required');

	  var StampPage = _react2['default'].createClass({
	    displayName: (0, _humps.pascalize)(routeName),

	    mixins: [stampPageMixin, _mixinsScrollStateMixin2['default'], _mixinsScreenSizeMixin2['default'], _mixinsPureRenderMixin2['default']],

	    propTypes: {
	      params: _react.PropTypes.shape({
	        stampSegment: _react.PropTypes.string.isRequired
	      }).isRequired
	    },

	    statics: {
	      willTransitionTo: function willTransitionTo(transition, params, query, callback) {

	        // If user scrolls past the viewport and we replace page content before
	        // the scroll fully "returns", scroll position may get messed up in WebKit.

	        // We will attempt to wait for elastic scroll,
	        // but carry on if it doesn't happen soon enough.

	        if ((0, _utilsBrowser.isMobile)()) {
	          return callback();
	        }

	        _Promise.race([(0, _utilsWaitForElasticScroll2['default'])(), (0, _utilsDelay2['default'])(2000)]).then(callback);
	      }
	    },

	    getInitialState: function getInitialState() {
	      return this.getLightboxState();
	    },

	    parseStampId: function parseStampId(props) {
	      props = props || this.props;

	      var _parseStampSegment = (0, _utilsParseStampSegment2['default'])(props.params.stampSegment);

	      var stampId = _parseStampSegment.stampId;

	      return stampId;
	    },

	    getScrollState: function getScrollState(scrollY, previousScrollY) {
	      return {
	        isScrolled: scrollY > 52,
	        isScrollingDown: scrollY > 52 && previousScrollY < scrollY,
	        hasScrolledToInfo: this.hasScrolledToOffset(this._infoPanelOffsetTop),
	        hasScrolledToNextUp: this.hasScrolledToOffset(this._nextUpOffsetTop),
	        hasScrolledPastNextUp: this.hasScrolledPastOffset(this._nextUpOffsetTop)
	      };
	    },

	    getLightboxState: function getLightboxState() {
	      return {
	        lightboxImageUuid: _storesLightboxStore2['default'].getActiveImageUuid(),
	        lightboxSectionType: _storesLightboxStore2['default'].getActiveSectionType()
	      };
	    },

	    getStateFromStores: function getStateFromStores(props) {
	      var stamps = this.getPage(),
	          stampId = this.parseStampId(props),
	          index = stamps.map(function (s) {
	        return s.id;
	      }).indexOf(stampId),
	          stamp = _storesStampStore2['default'].get(stampId),
	          isLastPage = this.isLastPage(),
	          perFirstPage = this.getPerFirstPageCount(),
	          needsNextPage = !isLastPage && stamps.length - index <= perFirstPage;

	      return {
	        stamp: stamp,
	        primaryZine: stamp && this.getStampPrimaryZine(stamp.id),
	        nextStamps: stamps.slice(index + 1),
	        nextUpTitle: this.getNextUpTitle(),
	        needsNextPage: needsNextPage,
	        isExpectingPage: this.isExpectingPage(),
	        isLastPage: isLastPage,
	        routeParams: _underscore2['default'].omit(props.params, 'stampSegment')
	      };
	    },

	    getPerFirstPageCount: function getPerFirstPageCount() {
	      return Math.max(MIN_NEXT_STAMP_COUNT, (0, _utilsGetStampCountPerRow2['default'])(this.getScreenSize(), MIN_NEXT_STAMP_COUNT));
	    },

	    getNextUpStampItemProps: function getNextUpStampItemProps(stamp) {
	      var isTrending = false,
	          primaryZine = null;

	      if (this.shouldShowPrimaryZineInNextUp()) {
	        primaryZine = this.getStampPrimaryZine(stamp.id);
	      }

	      return {
	        isTrending: isTrending,
	        primaryZine: primaryZine
	      };
	    },

	    getRouteProps: function getRouteProps() {
	      return {
	        routeName: routeName,
	        routeParams: this.state.routeParams
	      };
	    },

	    hasEnoughStampsForNextUp: function hasEnoughStampsForNextUp() {
	      var _state = this.state;
	      var nextStamps = _state.nextStamps;
	      var isExpectingPage = _state.isExpectingPage;
	      var isLastPage = _state.isLastPage;

	      return nextStamps.length || !isLastPage || isExpectingPage;
	    },

	    getNavigationContext: function getNavigationContext() {
	      var _state2 = this.state;
	      var stamp = _state2.stamp;
	      var primaryZine = _state2.primaryZine;

	      if (!stamp) {
	        return null;
	      }

	      var stampId = stamp.id;
	      var _state3 = this.state;
	      var isScrolled = _state3.isScrolled;
	      var isScrollingDown = _state3.isScrollingDown;
	      var hasScrolledToInfo = _state3.hasScrolledToInfo;
	      var hasScrolledPastNextUp = _state3.hasScrolledPastNextUp;
	      var nextUpTitle = this.state.nextUpTitle;

	      if (!this.hasEnoughStampsForNextUp()) {
	        // Special case: we'll render <TrendingNextUp /> instead so title should match it
	        nextUpTitle = _mixinsStampPageMixins2['default'].Feed.getNextUpTitle.call(this);
	      }

	      return [_constantsNavigationContextTypes2['default'].STAMP, {
	        stampId: stampId,
	        isScrolled: isScrolled,
	        isScrollingDown: isScrollingDown,
	        hasScrolledToInfo: hasScrolledToInfo,
	        hasScrolledPastNextUp: hasScrolledPastNextUp,
	        nextUpTitle: nextUpTitle,
	        primaryZineSlug: primaryZine && primaryZine.slug
	      }];
	    },

	    getPageControls: function getPageControls() {
	      var stamp = this.state.stamp;

	      if (!stamp) {
	        return null;
	      }

	      var stampId = stamp.id;
	      var _state4 = this.state;
	      var hasScrolledToNextUp = _state4.hasScrolledToNextUp;
	      var hasScrolledToInfo = _state4.hasScrolledToInfo;
	      var imageUuid = _state4.lightboxImageUuid;
	      var sectionType = _state4.lightboxSectionType;

	      var pendingZine = this.getStampPendingZine(stampId);

	      if (imageUuid) {
	        return [_constantsPageControlsTypes2['default'].IMAGE, { stampId: stampId, imageUuid: imageUuid, sectionType: sectionType }];
	      } else if (pendingZine && !hasScrolledToNextUp) {
	        var zineSlug = pendingZine.slug;

	        return [_constantsPageControlsTypes2['default'].STAMP_REVIEW, { stampId: stampId, zineSlug: zineSlug }];
	      } else if (!hasScrolledToInfo) {
	        return [_constantsPageControlsTypes2['default'].STAMP, { stampId: stampId }];
	      }
	    },

	    getAppContext: function getAppContext() {
	      var _ref2 = this.getNavigationContext() || [];

	      var _ref22 = _slicedToArray(_ref2, 2);

	      var navigationContextType = _ref22[0];
	      var navigationContextOptions = _ref22[1];

	      var _ref3 = this.getPageControls() || [];

	      var _ref32 = _slicedToArray(_ref3, 2);

	      var pageControlsType = _ref32[0];
	      var pageControlsOptions = _ref32[1];
	      var activeStamp = this.state.stamp;

	      return {
	        navigationContextType: navigationContextType,
	        navigationContextOptions: navigationContextOptions,
	        pageControlsType: pageControlsType,
	        pageControlsOptions: pageControlsOptions,
	        activeStamp: activeStamp
	      };
	    },

	    componentWillMount: function componentWillMount() {
	      this.resetRecordedOffsets();
	    },

	    componentDidMount: function componentDidMount() {
	      this.requestPage(true);
	      this.handleStampIdChange(this.props, false);
	      this.preloadNextStamps();

	      _storesLightboxStore2['default'].addChangeListener(this.handleLightboxChanged);
	    },

	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	      if (!(0, _reactLibShallowEqual2['default'])(this.props.params, nextProps.params)) {
	        this.setState(this.getStateFromStores(nextProps));
	        this.handleStampIdChange(nextProps, true);
	        this.resetRecordedOffsets();
	      }
	    },

	    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	      if (this.state.needsNextPage && !this.state.isExpectingPage) {
	        this.requestPage();
	      }

	      var prevStamp = prevState.stamp,
	          stamp = this.state.stamp;

	      if (prevStamp === stamp) {
	        return;
	      }

	      if (!prevStamp || !stamp || prevStamp.id !== stamp.id) {
	        this.preloadNextStamps();
	      }
	    },

	    resetRecordedOffsets: function resetRecordedOffsets() {
	      this._infoPanelOffsetTop = 0;
	      this._nextUpOffsetTop = 0;
	    },

	    handleLightboxChanged: function handleLightboxChanged() {
	      this.setState(this.getLightboxState());
	    },

	    handleStampIdChange: function handleStampIdChange(props, isNextStamp) {
	      var stampSegment = props.params.stampSegment;

	      _actionsStampActionCreators2['default'].requestStamp(stampSegment, ['content', 'zines', 'images']);
	      _actionsStampActionCreators2['default'].incrementStampViews(stampSegment, isNextStamp);
	    },

	    preloadNextStamps: function preloadNextStamps() {
	      if (!this.state.nextStamps) {
	        return;
	      }

	      var count = Math.min(MAX_PREFETCH_COUNT, this.getPerFirstPageCount());
	      this.state.nextStamps.slice(0, count).forEach(function (nextStamp) {
	        return _actionsStampActionCreators2['default'].requestStamp(nextStamp.id, ['content', 'zines']);
	      });
	    },

	    componentWillUnmount: function componentWillUnmount() {
	      _storesLightboxStore2['default'].removeChangeListener(this.handleLightboxChanged);
	    },

	    render: function render() {
	      var stamp = this.state.stamp;
	      if (!stamp) {
	        return _react2['default'].createElement(_atomsLoader2['default'], { absoluteCenter: true });
	      }

	      return _react2['default'].createElement(
	        _AppContext2['default'],
	        this.getAppContext(),
	        _react2['default'].createElement(
	          _atomsDocumentTitle2['default'],
	          { title: stamp.title },
	          _react2['default'].createElement(_stampStamp2['default'], { stamp: stamp,
	            primaryZine: this.state.primaryZine,
	            nextUp: this.renderNextUp(),
	            onInfoPanelOffsetTopChange: this.handleInfoPanelOffsetTopChange,
	            isInViewer: true })
	        )
	      );
	    },

	    renderNextUp: function renderNextUp() {
	      if (!this.hasEnoughStampsForNextUp()) {
	        return this.renderTrendingNextUp();
	      }

	      var _state5 = this.state;
	      var nextStamps = _state5.nextStamps;
	      var primaryZine = _state5.primaryZine;
	      var nextUpTitle = _state5.nextUpTitle;
	      var isExpectingPage = _state5.isExpectingPage;
	      var isLastPage = _state5.isLastPage;
	      var colors = this.getColors(primaryZine);

	      return _react2['default'].createElement(
	        _atomsOffsetMonitor2['default'],
	        { onOffsetTopChange: this.handleNextUpOffsetTopChange },
	        _react2['default'].createElement(
	          _organismsContainer2['default'],
	          { key: 'next-' + this.parseStampId(),
	            context: 'Stamp',
	            style: { backgroundColor: '#' + colors.background },
	            color: colors.text },
	          _react2['default'].createElement(_organismsGroup2['default'], { type: 'stamps',
	            mode: 'grid',
	            columns: MIN_NEXT_STAMP_COUNT,
	            context: 'page',
	            color: colors.text,
	            title: nextUpTitle,
	            items: nextStamps,
	            itemProps: this.getRouteProps(),
	            getItemProps: this.getNextUpStampItemProps,
	            isExpectingPage: isExpectingPage,
	            isLastPage: isLastPage,
	            loadNextPage: this.requestPage,
	            isInvalidated: false,
	            perFirstPage: this.getPerFirstPageCount() })
	        )
	      );
	    },

	    renderTrendingNextUp: function renderTrendingNextUp() {
	      return _react2['default'].createElement(
	        _atomsOffsetMonitor2['default'],
	        { onOffsetTopChange: this.handleNextUpOffsetTopChange },
	        _react2['default'].createElement(
	          _organismsContainer2['default'],
	          { context: 'Stamp' },
	          _react2['default'].createElement(_organismsTrendingNextUp2['default'], { perFirstPage: this.getPerFirstPageCount(),
	            itemProps: this.getRouteProps(),
	            getItemProps: this.getNextUpStampItemProps })
	        )
	      );
	    },

	    handleNextUpOffsetTopChange: function handleNextUpOffsetTopChange(nextUpOffsetTop) {
	      this._nextUpOffsetTop = nextUpOffsetTop;
	      this.updateScrollState();
	    },

	    handleInfoPanelOffsetTopChange: function handleInfoPanelOffsetTopChange(infoPanelOffsetTop) {
	      this._infoPanelOffsetTop = infoPanelOffsetTop;
	      this.updateScrollState();
	    }
	  });

	  if (module.makeHot) {
	    StampPage = module.makeHot(StampPage, routeName);
	  }

	  return StampPage;
	}

	module.exports = createStampPage;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(386)(module)))

/***/ },

/***/ 789:
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _Promise = __webpack_require__(99)['default'];

	function delay(ms) {
	  return new _Promise(function (resolve) {
	    return setTimeout(resolve, ms);
	  });
	}

	module.exports = delay;

/***/ }

});


/** WEBPACK FOOTER **
 ** 2.chunk.4b94e0830345b16e9fab.js
 **/